// Thư viện khối Facebook cho Tự dựng — selector KHÔNG phụ thuộc tài khoản, dò trên Facebook thật 2026-09-21 16:30 (bản đã học
// fb-binh-luan-bai-viet dùng aria-label "Bình luận dưới tên Nam" gắn với một tài khoản → không dùng làm khối chung):
//   thẻ bài trong kết quả tìm kiếm: div[role=feed] > div · nút bình luận trong thẻ: div[role=button][aria-label="Viết bình luận"] (bấm → mở
//   bài/reel trong hộp thoại) · ô nhập Lexical: div[role=textbox][contenteditable=true][aria-label^="Bình luận dưới tên"] (trong dialog, ngoài thẻ)
//   · bài nhóm chưa tham gia có nút "Tham gia" → lọc bỏ. Nội dung bài: [data-ad-rendering-role=story_message] (fallback chữ dài nhất).
import type { KhoiMau } from "./tu-dung";
import { kemAnhHoc, TS_KEM_ANH_TAT_CA } from "./kem-anh";
import { themChiBaiLienQuan } from "./chi-lien-quan"; // (05/10) "Chỉ bình luận bài liên quan" co/khong cho mọi khối có bước chấm

export const FB_URL = "https://www.facebook.com/";

// KÈM ẢNH (04/10/2026, src/shared/kem-anh.ts). Khảo sát thật 04/10: ô bình luận ("Bình luận dưới tên …") và ô trả lời ("Trả lời với vai trò …") có nút
// div[role=button] aria-label "Đính kèm một ảnh hoặc video" nằm trong khung form của chính ô đó (bai_minh_binh_luan #60–#64, tra_loi_binh_luan #50–#55 —
// theo hình học). VẪN GIẢ ĐỊNH (khảo sát chỉ ghi phần tử thấy được, input file ẩn không ghi; không được đăng thật):
//  · input[type=file] ẩn nằm trong CÙNG khung soạn với ô Lexical (bot tìm khung nhỏ nhất bao ô soạn
//    có input file và chỉ một ô soạn — không đính vào khung của bài/hộp thoại khác);
//  · ảnh xem trước là <img src="blob:…"> trong khung soạn; bình luận đăng xong có ảnh <img> trong liên kết a[href*="photo"] của div[role=article]
//    TRONG CÙNG chứa câu vừa gửi.
const FB_HAU_KIEM_ANH = [{ t: "locator_visible" as const, target: { describe: "ảnh trong bình luận vừa đăng (bình luận chứa câu vừa gửi)", ladder: [
  { t: "xpath" as const, xpath: '(//div[@role="article"][contains(normalize-space(.), {{ xpath_chu(cau_da_go) }})][not(.//div[@role="article"][contains(normalize-space(.), {{ xpath_chu(cau_da_go) }})])]//a[contains(@href,"photo")]//img)[1]' },
] } }];

export const POST_LIST_SPEC = {
  mode: "list",
  list: { describe: "bài viết trong kết quả tìm kiếm", ladder: [{ t: "css", sel: 'div[role="feed"] > div' }] },
  fields: {
    tac_gia: { sel: 'h3 a[role="link"], h4 a[role="link"], strong a[role="link"]', attr: "text", alt: ['a[role="link"][aria-label]', 'a[role="link"]'] },
    tac_gia_url: { sel: 'h3 a[role="link"], h4 a[role="link"], strong a[role="link"]', attr: "href" }, // hồ sơ tác giả — nhận ra bài của CHÍNH nick (bo_cua_nick)
    noi_dung: { sel: '[data-ad-rendering-role="story_message"]', attr: "text", alt: ['[data-ad-comet-preview="message"]', 'span[dir="auto"]'], fallback: "longest_text" },
    nut_tham_gia: { sel: 'div[role="button"]', attr: "text", regex: "^Tham gia$" },
    anh_url: { sel: null, attr: "anh_lon" }, // ảnh lớn nhất của bài (bỏ avatar) — AI nhìn khi chữ bài ngắn
    // Khoá nhận dạng bài. ĐO THẬT trên Facebook 2026-09-23, trang /search/posts?q=… (6 mục):
    //   /posts/ 0 · story_fbid= 0 · /permalink/ 0 · /videos/ 0 · rê chuột vào giờ đăng cũng KHÔNG sinh thêm link nào.
    // Kết quả tìm kiếm chỉ có link nhóm (/groups/<id>), link tác giả (/groups/<id>/user/<id>) và link ảnh (/photo).
    // Chỉ /photo là của RIÊNG bài: query có fbid toàn chữ số (15–18 chữ số, 3/6 mục có). Nên giữ đúng một selector
    // này thay vì bốn selector đoán mò không khớp gì; bài không có ảnh thì lùi về nội dung như cũ.
    lien_ket: { sel: 'a[href*="/photo"]', attr: "href" },
    // L-17 (người dùng chốt: CHỈ bình luận bài trong NHÓM ĐÃ THAM GIA): bài nhóm có liên kết /groups/<id> ở phần đầu (tên nhóm, tác giả
    // /groups/<id>/user/<id>); bài của Trang ("Theo dõi") và bài cá nhân thì không. Bỏ liên kết nằm TRONG thân bài (Trang dẫn link nhóm).
    lien_ket_nhom: { sel: 'a[href*="/groups/"]:not([data-ad-rendering-role="story_message"] a):not([data-ad-comet-preview="message"] a)', attr: "href" },
  },
  // Khoá sổ cái: ƯU TIÊN liên kết ảnh của bài (ổn định khi bài bị sửa chữ), không có mới lùi về nội dung.
  item_key: ["lien_ket", "noi_dung"],
  // L-13 phần "tự bình luận bài mình" (ket-qua-FB C3: tìm "capcut" ra bài CỦA CHÍNH nick, AI chấm liên quan): bỏ bài của nick đang đăng nhập.
  bo_cua_nick: { ten: "tac_gia", lien_ket: "tac_gia_url" },
  // L-1 (đo thật 2026-09-30, test-that/fb/soi-feed.mjs): kết quả tìm kiếm tải lười/ảo hoá — 13 khung thì 7 RỖNG (chưa vẽ / bị làm rỗng khi cuộn qua).
  // Khung không có cả tác giả lẫn nội dung không phải bài → không tính vào "N mục", không lọt qua các bộ lọc sau. KHÔNG lọc bằng selector danh sách
  // (:has(...)): khi Facebook vẽ/làm rỗng khung giữa lúc chạy, vị trí mục đổi → bấm "Viết bình luận" nhầm sang bài khác.
  bo_muc_rong: ["tac_gia", "noi_dung"],
  // L-1 phần còn lại: Facebook chỉ giữ ~7 bài có chữ cùng lúc (ảo hoá) → cuộn và GOM DẦN tới 15 bài có nội dung (tối đa 6 lượt cuộn) để sau các
  // bộ lọc (nhóm chưa tham gia, liên quan) vẫn còn đủ bài; bình luận thì runner cuộn khung bài vào màn hình trước (src/background/runner.ts gomDan).
  cuon_gom: { muc: 15, lan: 6 },
};

// Ô bình luận của MỘT bài (dùng với vung "bai"): nhãn "Bình luận dưới tên …" (trang/feed), "Trả lời dưới tên …" (bài mở dạng hộp thoại — đo thật
// 2026-10-01), "Viết bình luận…", giao diện tiếng Anh "Comment as …"/"Write a comment…"; cuối cùng ô Lexical trong hộp thoại bài.
const O_BINH_LUAN_BAI = [
  { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Bình luận dưới tên"]' },
  { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Trả lời dưới tên"]' },
  { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Viết bình luận"]' },
  { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Comment as"]' },
  { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Write a comment"]' },
  { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"][data-lexical-editor="true"]' },
  { t: "css", sel: 'div[role="textbox"][contenteditable="true"][data-lexical-editor="true"]' },
  { t: "model", prompt: "ô nhập bình luận (contenteditable) của bài viết đang mở — KHÔNG phải ô chat/tin nhắn ('Viết cho …', Messenger)" },
];

const DANG_ACTIONS = [
  { kind: "click", target: { describe: "nút 'Viết bình luận' của bài viết này", within: "item", ladder: [
    { t: "css", sel: 'div[role="button"][aria-label="Viết bình luận"]' },
    { t: "css", sel: 'div[role="button"][aria-label="Bình luận"]' },
    { t: "model", prompt: "nút Bình luận / Viết bình luận của bài viết đang xét" },
  ] } },
  // L-42 (Facebook thật 2026-10-01): bài mở dạng HỘP THOẠI có ô "Trả lời dưới tên Nam" (không phải "Bình luận dưới tên…"), vẽ muộn; trong lúc đó ô
  // Lexical DUY NHẤT trên trang là ô chat Messenger "Viết cho …" → nấc chung cũ gõ vào chat = gửi tin nhắn riêng. Nay: vung "bai" (chỉ ô trong hộp
  // thoại bài / trong mục), ô chat bị loại ở mọi nấc (src/content/o-chat.ts); ô bài chưa vẽ thì bước CHỜ rồi dừng, không gõ chỗ khác.
  { kind: "type", target: { describe: "ô bình luận của bài viết này (Lexical, trong hộp thoại bài hoặc trong bài — không phải ô chat)", vung: "bai", ladder: O_BINH_LUAN_BAI }, text: "{{item.binh_luan}}", enter: true },
];

// MỘT bài đang mở theo địa chỉ (binh_luan_mot_bai): KHÔNG có vòng lặp nên không có item — lỗi thật L-5 (2026-09-30): dùng chung DANG_ACTIONS
// ("{{item.binh_luan}}", within:item) → "Giá trị không tồn tại cho {{ item.binh_luan }}" ở mọi lần chạy. Trang bài có thể kèm bài gợi ý bên dưới
// (nhiều nút/ô bình luận) → nấc xpath lấy cái ĐẦU TIÊN (của bài chính), css chỉ nhận khi khớp đúng một.
// L-5 (Facebook thật 2026-10-01 00:28): bài nhóm mở dạng HỘP THOẠI — nút "Viết bình luận" ĐẦU TIÊN trong DOM nằm sau hộp thoại (bị ẩn), nút thấy
// được là nút trong [role=dialog]; ô soạn nhãn "Trả lời dưới tên Nam" → "xpath: phần tử ẩn". Nay nút/ô trong hộp thoại bài được thử trước.
// Lỗi đăng NHẦM BÀI (04/10/2026, trang giả tests/e2e/trang-gia-anh.mjs ?cham_o&goi_y_san=1): ô của bài chính vẽ muộn trong khi ô "Bình luận dưới tên…"
// của BÀI GỢI Ý (hoặc bài trên nền sau hộp thoại) đang hiện → vùng "bai" nhận ô đó, nấc css "khớp đúng một" chọn nó → chữ + ảnh vào bài khác. Nay vùng
// "bai_dich" (src/content/dom.ts khungBaiDich): mọi nấc + tham chiếu bản đồ + AI chỉ + đính ảnh chỉ nhận phần tử của ĐÚNG bài đang mở (hộp thoại bài; không
// có thì bài ĐẦU TIÊN của trang); ô bài chính chưa vẽ → bước CHỜ, hết giờ thì dừng có lý do, không gõ. Cần plugin ≥ 0.1.53 (bundle tự khai can_plugin).
const DANG_MOT_BAI_ACTIONS = dangMotBaiActions("{{binh_luan}}");
function dangMotBaiActions(chu: string) { return [
  { kind: "click", target: { describe: "nút 'Viết bình luận' của bài đang mở", vung: "bai_dich", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Viết bình luận"]' },
    { t: "xpath", xpath: '(//div[@role="button"][@aria-label="Viết bình luận"])[1]' },
    { t: "xpath", xpath: '(//div[@role="button"][@aria-label="Bình luận" or @aria-label="Comment" or @aria-label="Leave a comment"])[1]' },
    { t: "model", prompt: "nút Bình luận / Viết bình luận của bài viết chính đang mở (không phải bài gợi ý bên dưới)" },
  ] } },
  { kind: "type", target: { describe: "ô bình luận (Lexical) của bài đang mở — không phải ô chat, không phải ô của bài gợi ý / bài khác", vung: "bai_dich", ladder: [
    { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Bình luận dưới tên"]' },
    { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-label^="Trả lời dưới tên"]' },
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"][data-lexical-editor="true"]' },
    { t: "xpath", xpath: '(//div[@role="textbox"][@contenteditable="true"][starts-with(@aria-label,"Bình luận dưới tên") or starts-with(@aria-label,"Viết bình luận") or starts-with(@aria-label,"Trả lời dưới tên")])[1]' },
    { t: "model", prompt: "ô nhập bình luận (contenteditable) của bài viết chính đang mở — KHÔNG phải ô chat/tin nhắn" },
  ] }, text: chu, enter: true },
]; }

// Đăng bài trong NHÓM. Bản đồ giao diện (dò thật 2026-09-23, trang `nhom` + `hop_thoai_dang_nhom`) cho thấy:
// ô soạn là div[role=button] CHỮ "Bạn viết gì đi..." — KHÔNG có aria-label, nên nấc đầu phải là nấc CHỮ;
// bấm vào mới mở role=dialog "Tạo bài viết" chứa ô Lexical và nút "Đăng".
const DANG_NHOM_ACTIONS = [
  { kind: "click", target: { describe: "ô soạn 'Bạn viết gì đi...' của nhóm", ladder: [
    // Nấc chữ khớp TRỌN chữ (findByText so bằng, không phải chứa) → phải đúng cả dấu ba chấm như Facebook hiện.
    { t: "text", text: "Bạn viết gì đi...", tag: "div" },
    { t: "xpath", xpath: '(//div[@role="button"][contains(normalize-space(),"Bạn viết gì")])[1]' },
    { t: "css", sel: 'div[role="button"][aria-label^="Bạn viết gì"]' },
    { t: "model", prompt: "ô mở soạn bài của nhóm (chữ 'Bạn viết gì đi...')" },
  ] } },
  // Lỗi (2026-10-02): nấc 2 cũ 'div[role=textbox][contenteditable][data-lexical-editor]' ở BẤT KỲ đâu → hộp "Tạo bài viết" vẽ chậm thì nấc này nhận
  // ô bình luận dưới bài khác / ô của hộp thoại bài đang mở (Facebook luôn có nhiều ô Lexical) → bài nhóm gõ nhầm chỗ. Nay vung "tao_bai": mọi nấc
  // (kể cả nấc AI, gợi ý bản đồ) chỉ nhận phần tử NẰM TRONG hộp thoại có tiêu đề "Tạo bài viết"; hộp chưa vẽ → bước CHỜ, hết giờ thì dừng, không gõ.
  { kind: "type", target: { describe: "ô soạn bài trong hộp thoại 'Tạo bài viết'", vung: "tao_bai", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"][data-lexical-editor="true"]' },
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"]' },
    { t: "model", prompt: "ô nhập nội dung bài trong hộp thoại Tạo bài viết" },
  ] }, text: "{{bai_viet}}" },
  { kind: "click", target: { describe: "nút Đăng trong hộp thoại 'Tạo bài viết'", vung: "tao_bai", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Đăng"]' },
    { t: "text", text: "Đăng", tag: "div", exact: true },
    { t: "model", prompt: "nút Đăng của hộp thoại Tạo bài viết (không phải nút Ảnh/video)" },
  ] } },
];

// TỰ CHỌN NHÓM ĐỂ ĐĂNG (04/10/2026, địa chỉ nhóm để trống): dữ liệu nhóm của chính bot trước (src/shared/nhom-fb.ts), không có nhóm hợp mới mở trang
// "Nhóm của bạn" (nhom_da_vao) để bổ sung; mỗi ứng viên được mở ra kiểm có ô soạn bài (kiem_dang = nấc đầu của ô soạn DANG_NHOM_ACTIONS) — không có thì
// ghi "chặn đăng" và thử nhóm kế. Các giá trị là chữ có {{…}} (tham số của khối), runner thay lúc chạy.
const CHON_NHOM_DANG = {
  url: "{{nhom_url}}", bien: "nhom_chon", tu_khoa: "{{tu_khoa_chon_nhom}}", chu_de: "{{chu_de}}", gian_cach_ngay: "{{gian_cach_dang_ngay}}",
  nhom_da_vao: "{{goc}}groups/joins/", toi_da_thu: 3,
  kiem_dang: { describe: "ô soạn 'Bạn viết gì đi...' của nhóm", ladder: [
    { t: "text", text: "Bạn viết gì đi...", tag: "div" },
    { t: "xpath", xpath: '(//div[@role="button"][contains(normalize-space(),"Bạn viết gì")])[1]' },
    { t: "css", sel: 'div[role="button"][aria-label^="Bạn viết gì"]' },
  ] },
};

// TƯƠNG TÁC VỚI MỘT BÌNH LUẬN CỤ THỂ (của nick khác trong đội): tìm bình luận theo CHỮ nó chứa, không cần permalink —
// Facebook không cho lấy địa chỉ bình luận một cách chắc chắn, mà chữ thì chính đội mình vừa đăng nên biết chắc.
// Mỗi bình luận là div[role=article] (bản đồ giao diện dò thật 2026-09-23) → tìm article chứa chữ rồi bấm nút BÊN TRONG nó.
// Lỗi bấm NHẦM BÌNH LUẬN (04/10/2026, trang giả tests/e2e/trang-gia-anh.mjs /anhfb/tl?bai_article=1): khung bài CŨNG là role=article (bọc mọi bình luận) →
// "article chứa chữ" khớp KHUNG BÀI trước (tổ tiên đứng trước trong thứ tự tài liệu) → bấm nút của bình luận ĐẦU TIÊN. Nay bình luận ĐÍCH (DK_BL_DICH) =
// article chứa chữ mà KHÔNG có article con nào cũng chứa chữ (bình luận trong cùng — như hậu kiểm ảnh FB_HAU_KIEM_ANH) và KHÔNG chứa nội dung bài
// (story_message) → không bao giờ là khung bài; phải có ĐÚNG MỘT bình luận như vậy (hai bình luận cùng chứa chữ → không đoán, bước dừng). Nút/ô phải thuộc
// CHÍNH bình luận đó (CUA_BL_DICH: article GẦN NHẤT bao nó là bình luận đích — nút của phản hồi lồng bên trong không tính). Chỉ đổi xpath: plugin cũ chạy được.
// Không dùng vị trí trên trục ngược (ancestor::x[1], preceding::x[1]) — bộ XPath của jsdom (test) tính sai thứ tự đó; diễn đạt bằng "không có article nào
// xen giữa" cho chắc ở mọi bộ máy XPath.
const CHU_BL = "{{ xpath_chu(chu_binh_luan) }}";
const DK_BL_DICH = `[contains(normalize-space(.), ${CHU_BL})][not(.//div[@role="article"][contains(normalize-space(.), ${CHU_BL})])][not(.//*[@data-ad-rendering-role="story_message"])]`;
const BL_DICH_DUY_NHAT = `[count(//div[@role="article"]${DK_BL_DICH}) = 1]`;
// Bình luận đích là article gần nhất bao phần tử: có tổ tiên là bình luận đích và KHÔNG có article nào (vd. phản hồi lồng) nằm giữa.
const CUA_BL_DICH = `[ancestor::div[@role="article"]${DK_BL_DICH}][not(ancestor::div[@role="article"][ancestor::div[@role="article"]${DK_BL_DICH}])]${BL_DICH_DUY_NHAT}`;
// Article phản hồi (nhãn "Phản hồi của …"/"Reply by …") không phải bình luận cha — bỏ qua khi tìm bình luận đứng ngay trước một ô trả lời / một câu trả lời.
const KHONG_LA_PHAN_HOI = '[not(starts-with(@aria-label,"Phản hồi"))][not(starts-with(@aria-label,"Reply"))]';
// Phần tử đứng SAU bình luận DK (không nằm trong nó) và giữa hai cái KHÔNG có bình luận nào khác (article không phải phản hồi, không lồng trong bình luận DK):
// tức bình luận (cấp 1) gần nhất đứng trước phần tử là bình luận DK. Biểu thức điều kiện (dùng trong [ … ]).
const sauBinhLuan = (dk: string) => `preceding::div[@role="article"]${KHONG_LA_PHAN_HOI}${dk} and not(preceding::div[@role="article"]${KHONG_LA_PHAN_HOI}[preceding::div[@role="article"]${dk}])`;
const THICH_ACTIONS = [
  { kind: "click", target: { describe: "nút Thích của ĐÚNG MỘT bình luận chứa chữ đã cho (không phải của bài / bình luận khác)", khong_cua_nick: true, ladder: [
    { t: "xpath", xpath: `(//div[@role="button"][@aria-label="Thích"]${CUA_BL_DICH})[1]` },
    { t: "xpath", xpath: `(//div[@role="button"][@aria-label="Like"]${CUA_BL_DICH})[1]` },
    { t: "model", prompt: "nút Thích nằm trong bình luận chứa chữ {{chu_binh_luan}} (không phải nút Thích của bài viết)" },
  ] } },
];
// L-10 (đo DOM thật 2026-09-30, test-that/fb/do-o-tra-loi.mjs + anh/A1-tra-loi-o-soan.png): bấm "Trả lời" thì Facebook mở ô soạn NGOÀI
// article của bình luận (khối ngay SAU nó), nhãn "Trả lời với vai trò Nam" / "Trả lời dưới tên …"; ô "Bình luận dưới tên Nam" của bài vẫn ở
// cuối; trong article không có ô soạn lẫn nút "Đăng". → Tìm ô trả lời theo QUAN HỆ với bình luận: ô soạn có nhãn "Trả lời…/Reply…" đầu tiên
// ĐỨNG SAU article của bình luận (xpath following::). KHÔNG còn nấc "ô Lexical duy nhất trên trang": khi ô trả lời chưa mở, ô duy nhất là ô
// bình luận BÀI → gõ vào đó thành bình luận mới sai chỗ. Gửi bằng Enter như khối binh_luan_bai (Facebook gửi bình luận/trả lời khi Enter;
// không có nút "Đăng" gắn với ô trả lời) — bỏ bước bấm nút gửi (chỉ còn nấc AI, mặc định tắt → gõ xong là DỪNG).
const NHAN_TRA_LOI = '[starts-with(@aria-label,"Trả lời") or starts-with(@aria-label,"Phản hồi") or starts-with(@aria-label,"Reply")]';
const TRA_LOI_ACTIONS = [
  // khong_cua_nick (ket-qua-FB K2b: bot "tự cảm ơn" bình luận của chính nick): bình luận của nick đang đăng nhập → không bấm, bước dừng, lý do rõ.
  { kind: "click", target: { describe: "nút Phản hồi của ĐÚNG MỘT bình luận chứa chữ đã cho (không phải bình luận khác)", khong_cua_nick: true, ladder: [
    { t: "xpath", xpath: `(//div[@role="button"][@aria-label="Phản hồi" or @aria-label="Reply"]${CUA_BL_DICH})[1]` },
    { t: "xpath", xpath: `(//div[@role="button"][normalize-space()="Phản hồi" or normalize-space()="Trả lời"]${CUA_BL_DICH})[1]` },
    { t: "model", prompt: "nút Phản hồi/Trả lời của bình luận chứa chữ {{chu_binh_luan}}" },
  ] } },
  { kind: "type", target: { describe: "ô trả lời vừa mở của bình luận đó", ladder: [
    // Bố cục cũ/khác: ô soạn nằm TRONG article của bình luận đích.
    { t: "xpath", xpath: `(//div[@role="textbox"][@contenteditable="true"]${CUA_BL_DICH})[1]` },
    // Facebook hiện tại: ô soạn "Trả lời…" mở NGAY SAU article của bình luận — bình luận (không tính phản hồi) đứng gần nhất trước ô phải là bình luận đích
    // (ô của bình luận đứng trước / đứng sau không được nhận).
    { t: "xpath", xpath: `(//div[@role="textbox"][@contenteditable="true"]${NHAN_TRA_LOI}[not(ancestor::div[@role="article"]${DK_BL_DICH})][${sauBinhLuan(DK_BL_DICH)}]${BL_DICH_DUY_NHAT})[1]` },
    { t: "model", prompt: "ô nhập trả lời vừa mở dưới bình luận chứa chữ {{chu_binh_luan}} (KHÔNG phải ô 'Bình luận dưới tên…' của bài)" },
  ] }, text: "{{cau_tra_loi}}", enter: true },
];
// Câu trả lời nằm DƯỚI ĐÚNG bình luận cha (04/10/2026): phần tử sâu nhất chứa câu ĐÃ GÕ ({{cau_da_go}} — runner đặt bằng câu gõ thật, kể cả câu người duyệt
// sửa; plugin cũ không có biến này → bundle tự khai can_plugin) không phải ô soạn / script, mà hoặc nằm TRONG bình luận
// đích, hoặc bình luận (không tính phản hồi, không tính article bao chính câu trả lời) đứng gần nhất TRƯỚC nó là bình luận đích. Câu rơi xuống bình luận
// khác → không đạt.
const CHU_TL = "{{ xpath_chu(cau_da_go) }}";
const TL_DUOI_BL_DICH = `(//*[not(self::script or self::style or self::noscript or self::template or self::textarea)][contains(normalize-space(.), ${CHU_TL})]`
  + `[not(*[contains(normalize-space(.), ${CHU_TL})])][not(ancestor-or-self::*[@contenteditable="true"])]`
  + `[ancestor::div[@role="article"]${DK_BL_DICH} or (${sauBinhLuan(DK_BL_DICH)})])[1]`;
// Hậu kiểm gửi thật: câu hiện trên trang, nằm dưới ĐÚNG bình luận cha, VÀ không còn ô trả lời nào đang giữ chữ chưa gửi. Chỉ "thấy chữ" thì câu còn nằm
// trong ô soạn (Enter không gửi được) cũng khớp → báo đạt oan. Ô soạn không gắn với câu cụ thể để người duyệt sửa câu vẫn kiểm đúng.
const TRA_LOI_HAU_KIEM = [
  { t: "text_visible", text: "{{cau_tra_loi}}" },
  { t: "locator_visible", target: { describe: "câu trả lời nằm dưới ĐÚNG bình luận cha (bình luận chứa chữ đã cho)", ladder: [{ t: "xpath", xpath: TL_DUOI_BL_DICH }] } },
  { t: "locator_gone", target: { describe: "ô trả lời còn chữ chưa gửi", ladder: [
    { t: "xpath", xpath: `//div[@role="textbox"][@contenteditable="true"]${NHAN_TRA_LOI}[normalize-space(.)!=""]` },
  ] } },
];

// ===================== SEEDING NHÓM NHƯ NGƯỜI (2026-10-01) =====================
// Selector ĐO THẬT trên Facebook (Edge #1, nick test, CHỈ điều hướng + đọc DOM, không bấm gì) + khảo sát giao diện 23/09:
//  · /search/groups?q=…: div[role=feed] > div (data-virtualized) — mỗi khung một nhóm: div[role=article] có link ảnh đại diện
//    a[aria-label^="Ảnh đại diện của "][href*="/groups/"], link TÊN nhóm a[href*="/groups/"] (không aria-label, chữ = tên), chữ thẻ
//    "Tên Công khai · 446K thành viên · 90+ bài viết/ngày [1 người bạn là thành viên] Tham gia". Chưa tham gia: div[role=button]
//    [aria-label="Tham gia nhóm <tên>"] chữ "Tham gia". Đang chờ duyệt: chữ cuối "Đang chờ xem xét", KHÔNG có nút (nhóm "Mách Lẻo").
//  · trang nhóm /groups/<id>/: chưa tham gia → div[role=button][aria-label="Tham gia nhóm"] (HAI cái: đầu trang + thanh dính → nấc xpath [1]);
//    đã tham gia → div[role=button][aria-label="Đã tham gia"] (+ "Mời"). Ô "Bạn viết gì đi..." hiện cả với nhóm công khai chưa tham gia.
//  · bảng tin nhóm: div[role=feed] > div; khung đầu là thanh "sắp xếp bảng feed nhóm" (không bài → bo_muc_rong bỏ). Bài: nội dung
//    [data-ad-rendering-role=story_message], tác giả h2/h3/h4 a (href /groups/<id>/user/<id>), liên kết bài a[href*="/posts/"] (kèm
//    ?comment_id=… → regex lấy /groups/<nhóm>/posts/<số>), MỘT nút "Viết bình luận"; nút Thích CỦA BÀI = div[role=button][aria-label="Thích"]
//    KHÔNG nằm trong [role=article] (bình luận hiện ngay dưới bài là [role=article] "Bình luận dưới tên …" có nút "Thích" riêng). Đã thích →
//    aria-label "Gỡ Thích" (khảo sát trang_chu 23/09). Bài ảo hoá như kết quả tìm bài (L-1): cuộn qua thì khung cũ bị làm rỗng.
//  · CHƯA ĐO ĐƯỢC (không được bấm Tham gia trên nick thật): hộp thoại câu hỏi kiểm duyệt / nội quy sau khi bấm, và chữ nút sau khi gửi yêu cầu
//    → nhận nhiều cách viết (Hủy yêu cầu / Đang chờ xem xét / Đã gửi yêu cầu / tiếng Anh); E2E trang giả phủ các nhánh.
const NHOM_LIST_SPEC = {
  mode: "list",
  list: { describe: "nhóm trong kết quả tìm nhóm", ladder: [{ t: "css", sel: 'div[role="feed"] > div' }] },
  fields: {
    // Tên: link tên nhóm (không aria-label); dự phòng nhãn ảnh đại diện "Ảnh đại diện của <tên>". Bỏ link "1 người bạn là thành viên".
    ten_nhom: { sel: 'a[href*="/groups/"]:not([aria-label])', attr: "text", regex: "^(?:Ảnh đại diện của )?(?!.*thành viên)(.+)$", alt: ['a[aria-label^="Ảnh đại diện của"][href*="/groups/"]'] },
    // Địa chỉ gốc của nhóm (bỏ ?__tn__…) — khoá sổ cái, và trang mà bước tham gia / lướt mở.
    nhom_url: { sel: 'a[href*="/groups/"]', attr: "href", regex: "^(https?://[^?#]*?/groups/[^/?#]+/?)" },
    // Trạng thái theo CHỮ CUỐI thẻ (= chữ nút/nhãn): chờ duyệt → đã tham gia → chưa tham gia; còn lại khong_ro (máy không đoán).
    trang_thai: { sel: null, attr: "text", phan_loai: [
      { re: "(Đang chờ xem xét|Đã gửi yêu cầu|H[uủ]y yêu cầu|Huỷ yêu cầu|Pending|Requested|Cancel request)\\s*$", gt: "cho_duyet" },
      { re: "(Đã tham gia|Truy cập|Xem nhóm|Joined|Visit|View group)\\s*$", gt: "da_tham_gia" },
      { re: "(Tham gia|Join)\\s*$", gt: "chua_tham_gia" },
    ], mac_dinh: "khong_ro" },
    // Số thành viên: "446K", "1,5 triệu", "99" (đo thật: nhóm nhỏ chỉ có số — không lấy dấu cách thừa).
    thanh_vien: { sel: null, attr: "text", regex: "·\\s*([\\d.,]+(?:\\s*(?:K|N|M|B|triệu|nghìn|tỷ))?)\\s*(?:thành viên|members)" },
    che_do: { sel: null, attr: "text", regex: "(Công khai|Riêng tư|Public|Private)" },
    nut_tham_gia: { sel: 'div[role="button"][aria-label^="Tham gia nhóm"], div[role="button"][aria-label^="Join"]', attr: "aria-label" },
  },
  item_key: ["nhom_url", "ten_nhom"],
  bo_muc_rong: ["ten_nhom", "nhom_url"],
  cuon_gom: { muc: 12, lan: 3 },
};

// Bài trên BẢNG TIN nhóm / trang chủ (bước lướt). Như POST_LIST_SPEC nhưng liên kết bài là /posts/<số> của nhóm, có cờ "đã thích".
const BANG_TIN_SPEC = {
  mode: "list",
  // Nấc 2 — TRANG CHỦ facebook.com (đo thật 01/10, soi-trang-chu.mjs): không còn [role=feed]; mỗi bài là div[aria-posinset][aria-labelledby].
  list: { describe: "bài trên bảng tin", ladder: [{ t: "css", sel: 'div[role="feed"] > div' }, { t: "css", sel: "div[aria-posinset][aria-labelledby]" }] },
  fields: {
    tac_gia: { sel: 'h2 a[role="link"], h3 a[role="link"], h4 a[role="link"], strong a[role="link"]', attr: "text", alt: ['h2 a', 'h3 a', 'h4 a'] },
    tac_gia_url: { sel: 'h2 a[role="link"], h3 a[role="link"], h4 a[role="link"], strong a[role="link"]', attr: "href", alt: ['h2 a', 'h3 a', 'h4 a'] },
    noi_dung: { sel: '[data-ad-rendering-role="story_message"]', attr: "text", alt: ['[data-ad-comet-preview="message"]'] },
    lien_ket: { sel: 'a[href*="/posts/"], a[href*="/permalink/"]', attr: "href", regex: "(/groups/[^/?#]+/(?:posts|permalink)/\\d+)" },
    lien_ket_nhom: { sel: 'a[href*="/groups/"]:not([data-ad-rendering-role="story_message"] a):not([data-ad-comet-preview="message"] a)', attr: "href" },
    nut_tham_gia: { sel: 'div[role="button"]', attr: "text", regex: "^Tham gia$" },
    da_thich: { sel: 'div[role="button"][aria-label="Gỡ Thích"]:not([role="article"] *), div[role="button"][aria-label="Remove Like"]:not([role="article"] *)', attr: "aria-label" },
    anh_url: { sel: null, attr: "anh_lon" },
  },
  item_key: ["lien_ket", "noi_dung"],
  bo_muc_rong: ["tac_gia", "noi_dung"],
  // Lướt bảng tin: bài của CHÍNH nick không được chọn để thích / bình luận.
  bo_cua_nick: { ten: "tac_gia", lien_ket: "tac_gia_url" },
};

// Nút Thích CỦA BÀI trong mục (không phải nút Thích của bình luận hiện dưới bài).
const NUT_THICH_BAI = { describe: "nút Thích của bài viết này (không phải của bình luận)", within: "item", ladder: [
  { t: "css", sel: 'div[role="button"][aria-label="Thích"]:not([role="article"] *)' },
  { t: "css", sel: 'div[role="button"][aria-label="Like"]:not([role="article"] *)' },
] };
const DA_THICH_BAI = { describe: "nút 'Gỡ Thích' của bài (đã thích)", within: "item", ladder: [
  { t: "css", sel: 'div[role="button"][aria-label="Gỡ Thích"]:not([role="article"] *)' },
  { t: "css", sel: 'div[role="button"][aria-label="Remove Like"]:not([role="article"] *)' },
] };
// Thích một bài trong danh sách: đã thích (Gỡ Thích) → bỏ qua TRƯỚC khi hỏi duyệt (bấm lần hai = BỎ thích); sau khi bấm phải thấy "Gỡ Thích".
const THICH_BAI_LEARNED = {
  actions: [{ kind: "click", target: NUT_THICH_BAI }],
  bo_qua_khi: [{ khi: { t: "locator_visible", target: DA_THICH_BAI }, ghi: "bài này đã được thích từ trước — không bấm (bấm lần hai là bỏ thích)", gan: { da_thich: "co" } }],
  nhanh_ket_qua: [{ khi: { t: "locator_visible", target: DA_THICH_BAI }, ket: "ok", ghi: "đã thích bài", gan: { da_thich: "co" } }],
};

const NUT_THAM_GIA = { describe: "nút 'Tham gia nhóm' của nhóm đang mở", ladder: [
  { t: "xpath", xpath: '(//div[@role="main"]//div[@role="button"][@aria-label="Tham gia nhóm" or @aria-label="Join group" or @aria-label="Join Group"])[1]' },
  { t: "xpath", xpath: '(//div[@role="button"][@aria-label="Tham gia nhóm" or @aria-label="Join group"])[1]' },
] };
const DA_THAM_GIA = { describe: "nút 'Đã tham gia' (đã là thành viên)", ladder: [
  { t: "xpath", xpath: '(//div[@role="main"]//div[@role="button"][@aria-label="Đã tham gia" or @aria-label="Joined"])[1]' },
] };
const CHO_DUYET = { describe: "dấu hiệu đang chờ duyệt yêu cầu tham gia", ladder: [
  { t: "xpath", xpath: '(//div[@role="main"]//*[@role="button"][@aria-label="Hủy yêu cầu" or @aria-label="Huỷ yêu cầu" or @aria-label="Cancel request" or @aria-label="Đã gửi yêu cầu"] | //div[@role="main"]//*[normalize-space()="Đang chờ xem xét" or normalize-space()="Hủy yêu cầu" or normalize-space()="Huỷ yêu cầu" or normalize-space()="Đã gửi yêu cầu" or normalize-space()="Cancel request"])[1]' },
] };
// Hộp thoại câu hỏi kiểm duyệt / nội quy (sau khi bấm Tham gia): hộp thoại (không phải bảng Thông báo) có ô nhập / ô chọn VÀ nói tới câu hỏi / nội quy
// (nấc 1), hoặc có nút Gửi/Submit (nấc 2). CHƯA ĐO trên Facebook thật → bậc thang rộng. 05/10/2026: tham số tu_tra_loi_cau_hoi (mặc định co) → máy TỰ
// trả lời (src/shared/cau-hoi-nhom.ts, src/content/hop-cau-hoi.ts) rồi Gửi; câu bắt buộc đòi thông tin cá nhân / tắt tự trả lời → đóng hộp, "cần người".
const O_HOP_CAU_HOI = './/textarea or .//*[@role="textbox"] or .//*[@contenteditable="true"] or .//*[@role="checkbox"] or .//*[@role="radio"] or .//input[@type="checkbox"] or .//input[@type="radio"] or .//input[@type="text"]';
const HOP_CAU_HOI = { describe: "hộp thoại câu hỏi kiểm duyệt / nội quy nhóm", ladder: [
  { t: "xpath", xpath: `(//div[@role="dialog"][not(@aria-label="Thông báo")][${O_HOP_CAU_HOI}][contains(., "câu hỏi") or contains(., "Câu hỏi") or contains(., "nội quy") or contains(., "Nội quy") or contains(., "question") or contains(., "Question") or contains(., "rules") or contains(., "Rules") or contains(., "Trả lời câu hỏi") or contains(., "Answer questions")])[1]` },
  { t: "xpath", xpath: `(//div[@role="dialog"][not(@aria-label="Thông báo")][${O_HOP_CAU_HOI}][.//*[@role="button" or self::button][@aria-label="Gửi" or @aria-label="Submit" or normalize-space()="Gửi" or normalize-space()="Submit"]])[1]` },
] };
// Tham số bật/tắt tự trả lời (anKhiRong: sơ đồ cũ không có khoá này → lắp với mặc định "co").
const TS_TU_TRA_LOI_CAU_HOI = {
  ten: "tu_tra_loi_cau_hoi", kieu: "chuoi" as const, macDinh: "co", anKhiRong: true, luaChon: ["co", "khong"],
  moTa: "nhóm hỏi câu hỏi kiểm duyệt khi xin vào: co = AI tự trả lời ngắn đúng câu hỏi, chọn đáp án, đồng ý nội quy rồi Gửi (mặc định; câu đòi số điện thoại / email / địa chỉ / giấy tờ / mật khẩu thì không điền — bắt buộc thì để người làm); khong = đóng hộp, để người trả lời",
};
const DONG_HOP_CAU_HOI = { describe: "nút Đóng của hộp thoại câu hỏi (không gửi gì)", ladder: [
  { t: "xpath", xpath: '(//div[@role="dialog"][not(@aria-label="Thông báo")]//div[@role="button"][@aria-label="Đóng" or @aria-label="Close"])[1]' },
] };

// ===================== TRẢ LỜI MỌI BÌNH LUẬN DƯỚI BÀI CỦA MÌNH (FB 2026-10-03, người dùng duyệt) =====================
// Selector ĐO THẬT dùng lại: ô trả lời "Trả lời dưới tên …"/"Trả lời với vai trò …" mở NGAY SAU article bình luận + nút trả lời chỉ có CHỮ (L-10,
// 30/09); bình luận là div[role=article] nhãn "Bình luận dưới tên X vào …" (23/09); bài trên trang chủ là div[aria-posinset][aria-labelledby] (01/10).
// Giả định G1–G4 (trang giả tests/e2e/fb-bai-minh-gia.mjs dựng theo) — ĐỐI CHIẾU KHẢO SÁT THẬT 04/10/2026 (Edge thật, plugin 0.1.52, chỉ đọc; hàng rào
// tests/unit/dom/khao-sat-0410-hang-rao.test.ts). Khảo sát chỉ ghi phần tử thấy được + một số thuộc tính (KHÔNG ghi aria-posinset/aria-labelledby/dir,
// href ≥ 160 ký tự, chữ trơn) nên một phần vẫn là giả định:
//  G1 {{goc}}me/ → trang cá nhân: ĐÃ ĐO 04/10 gián tiếp — khảo sát bai_minh_binh_luan chờ được div[aria-posinset] trong role=main ở /me/ và bấm được
//     "Viết bình luận" (div[role=button] aria-label) trong bài; tác giả bài là h2 > a[role=link] (trang_ca_nhan_toi #154–#155); địa chỉ bài khi mở là
//     permalink.php?story_fbid=pfbid…&id=… (khớp nấc story_fbid=). CHƯA ĐO: liên kết bài có href sẵn trong bài (khảo sát không thấy href của liên kết giờ
//     đăng — hoặc chưa gán khi chưa rê chuột, hoặc dài ≥ 160 ký tự bị bỏ) và chữ bài ghim (trang khảo sát không có bài ghim).
//  G2 khối CHA của article bình luận cấp 1 chứa phần phản hồi: ĐÃ ĐO 04/10 theo hình học — nút "Xem N câu trả lời" nằm ngay dưới article, NGOÀI article
//     (tra_loi_binh_luan #37/#46); article nhãn "Bình luận dưới tên X vào …" ĐÃ ĐO; nút trả lời CHỈ CÓ CHỮ "Trả lời" (#44). CHƯA ĐO: ?comment_id= trong
//     href giờ đăng (liên kết giờ đăng có aria-label ngày "Chủ Nhật, 26 Tháng 7, 2026 lúc 12:31", href không có trong khảo sát), chữ trong div[dir=auto].
//  G3 nút mở thêm: LỆCH → ĐÃ SỬA 04/10. Facebook thật viết "Xem N câu trả lời" / "Xem thêm câu trả lời" (đa số, tra_loi_binh_luan #46 #74,
//     bang_tin_nhom #197 #277) — giả định cũ chỉ có "… phản hồi" nên KHÔNG bấm mở và KHÔNG nhận ra bình luận còn phản hồi ẩn (con_phan_hoi_an rỗng →
//     có thể trả lời trùng bình luận nick đã đáp). "Xem 1 phản hồi" (bang_tin_nhom #218) và "Xem thêm bình luận" (#252) có thật — giữ.
//  G4 bộ lọc: nút div[role=button] CHỮ "Phù hợp nhất" (không aria-label) ĐÃ ĐO (tra_loi_binh_luan #36) — khối vẫn KHÔNG đổi bộ lọc; chỉ bình luận đang hiện
//     + mở được bằng "Xem thêm".
const NUT_XEM_THEM_BL = { describe: "nút Xem thêm bình luận / phản hồi", vung: "bai", ladder: [
  { t: "xpath", xpath: '(//div[@role="button"][starts-with(normalize-space(.),"Xem thêm bình luận") or starts-with(normalize-space(.),"Xem bình luận trước") or starts-with(normalize-space(.),"Xem thêm phản hồi") or (starts-with(normalize-space(.),"Xem ") and contains(normalize-space(.)," phản hồi")) or (starts-with(normalize-space(.),"Xem ") and contains(normalize-space(.)," câu trả lời")) or (contains(normalize-space(.)," phản hồi") and string-length(normalize-space(.)) < 16 and translate(substring(normalize-space(.),1,1),"0123456789","") = "") or starts-with(normalize-space(.),"View more comments") or starts-with(normalize-space(.),"View previous comments") or starts-with(normalize-space(.),"View more replies") or (starts-with(normalize-space(.),"View ") and contains(normalize-space(.)," repl"))])[1]' },
] };
const BAI_MINH_SPEC = {
  mode: "list",
  list: { describe: "bài trên trang cá nhân của nick (mới nhất trước)", ladder: [
    { t: "css", sel: 'div[role="main"] div[aria-posinset][aria-labelledby]' },
    { t: "css", sel: 'div[role="main"] div[role="feed"] > div' },
  ] },
  fields: {
    lien_ket: { sel: 'a[href*="/posts/"], a[href*="story_fbid="], a[href*="/permalink/"], a[href*="/videos/"]', attr: "href" },
    ma_bai: { sel: 'a[href*="/posts/"], a[href*="story_fbid="], a[href*="/permalink/"], a[href*="/videos/"]', attr: "href", regex: "(?:/posts/|/permalink/|[?&]story_fbid=|[?&]fbid=|/videos/|/reel/)([A-Za-z0-9]+)" },
    tac_gia: { sel: 'h2 a[role="link"], h3 a[role="link"], h4 a[role="link"], strong a[role="link"]', attr: "text", alt: ["h2 a", "h3 a", "h4 a"] },
    ghim: { sel: null, attr: "text", regex: "(Bài viết đã ghim|Đã ghim|Pinned post|Featured)" },
  },
  // Mã bài TRƯỚC (cùng cách tính với ds_bai(địa chỉ dán tay) — src/shared/expr.ts maBaiFb) → sổ cái không trùng giữa hai cách mở bài.
  item_key: ["ma_bai", "lien_ket"],
  bo_muc_rong: ["lien_ket"],
  cuon_gom: { muc: 4, lan: 3 },
};
// Một bình luận cấp 1 = KHỐI CHA trực tiếp của article "Bình luận …" (G2) — gồm bình luận + phần phản hồi của nó. Trường đọc trong article (':scope >').
const BL_BAI_MINH_SPEC = {
  mode: "list",
  list: { describe: "bình luận cấp 1 dưới bài (khối gồm bình luận + phần phản hồi)", ladder: [
    { t: "css", sel: 'div:has(> div[role="article"][aria-label^="Bình luận"])' },
    { t: "css", sel: 'div:has(> div[role="article"][aria-label^="Comment"])' },
  ] },
  fields: {
    tac_gia: { sel: ':scope > div[role="article"]', attr: "aria-label", regex: "^(?:Bình luận dưới tên|Bình luận của|Comment by)\\s+(.+?)(?:\\s+vào\\s.*)?$" },
    tac_gia_url: { sel: ':scope > div[role="article"] a[href]', attr: "href" },
    noi_dung: { sel: ':scope > div[role="article"] div[dir="auto"]', attr: "text" }, // không dự phòng "chữ dài nhất": bình luận chỉ ảnh/sticker → rỗng (bị lọc)
    ma_bl: { sel: ':scope > div[role="article"] a[href*="comment_id="]', attr: "href", regex: "comment_id=(\\d+)" },
    anh_url: { sel: ':scope > div[role="article"]', attr: "anh_lon" },
    // Phản hồi của bình luận còn ẨN sau nút "Xem N câu trả lời" / "Xem N phản hồi" (đã bấm đủ giới hạn) → không biết nick đã trả lời chưa → bước lọc
    // sau bỏ. Chữ thật 04/10 (G3): "Xem 3 câu trả lời", "Xem thêm câu trả lời", "Xem 1 phản hồi".
    con_phan_hoi_an: { sel: 'div[role="button"]', attr: "text", regex: "^(?:Xem (?:thêm |tất cả )?(?:\\d+ )?(?:phản hồi|câu trả lời)|\\d+ (?:phản hồi|câu trả lời)|View (?:all )?(?:\\d+ )?(?:more )?repl(?:y|ies)|\\d+ repl(?:y|ies))" },
  },
  item_key: ["ma_bl", "noi_dung"],
  bo_cua_nick: { ten: "tac_gia", lien_ket: "tac_gia_url" },
  bo_nick_da_phan_hoi: { phan_hoi: ':scope > div[role="article"] div[role="article"], :scope > :not([role="article"]) div[role="article"]' },
  mo_rong: { nut: NUT_XEM_THEM_BL, lan: "{{ts.so_lan_xem_them}}", dem: 'div[role="article"]' },
};
// Bình luận đang làm, tìm theo MÃ bình luận (liên kết giờ đăng ?comment_id=<mã>&…). concat(@href,"&"): mã 11 không khớp nhầm 110. Bình luận không có mã
// đã bị lọc trước (không bao giờ tìm theo mã rỗng). Mọi thao tác vùng 'bai' + mục hiện tại (L-42): phần tử phải nằm trong KHỐI bình luận đang làm.
// (04/10/2026) Cùng lỗi với tra_loi_mot_binh_luan: khung bài là role=article thì nó cũng "chứa liên kết comment_id" → nút đầu tiên trong khung = nút của
// bình luận ĐẦU TIÊN (trong hộp thoại bài rào vùng không chặn được). Nay bình luận theo mã = article chứa liên kết mã (không tính liên kết của PHẢN HỒI
// "…comment_id=<mã>&reply_comment_id=…") mà không có article con nào cũng chứa; nút/ô phải thuộc CHÍNH article đó (article gần nhất bao nó).
// Liên kết giờ đăng của CHÍNH bình luận cấp 1 có thể mang "reply_comment_id=0" (khảo sát thật 04/10) — chỉ loại liên kết của câu TRẢ LỜI con (reply_comment_id khác 0).
const LK_MA_BL = './/a[contains(concat(@href, "&"), "comment_id={{item.ma_bl}}&")][not(contains(@href, "reply_comment_id=")) or contains(concat(@href, "&"), "reply_comment_id=0&")]';
const DK_BL_MA = `[${LK_MA_BL}][not(.//div[@role="article"][${LK_MA_BL}])]`;
const CUA_BL_MA = `[ancestor::div[@role="article"]${DK_BL_MA}][not(ancestor::div[@role="article"][ancestor::div[@role="article"]${DK_BL_MA}])]`;
const TL_BAI_MINH_ACTIONS = [
  { kind: "click", target: { describe: "nút Phản hồi của bình luận này", vung: "bai", khong_cua_nick: true, ladder: [
    { t: "xpath", xpath: `(//div[@role="button"][@aria-label="Phản hồi" or @aria-label="Trả lời" or @aria-label="Reply"]${CUA_BL_MA})[1]` },
    { t: "xpath", xpath: `(//div[@role="button"][normalize-space()="Phản hồi" or normalize-space()="Trả lời" or normalize-space()="Reply"]${CUA_BL_MA})[1]` },
  ] } },
  { kind: "type", target: { describe: "ô trả lời vừa mở của bình luận này (KHÔNG phải ô 'Bình luận dưới tên…' của bài)", vung: "bai", ladder: [
    { t: "xpath", xpath: `(//div[@role="textbox"][@contenteditable="true"]${CUA_BL_MA})[1]` },
    { t: "xpath", xpath: `(//div[@role="textbox"][@contenteditable="true"]${NHAN_TRA_LOI}[not(ancestor::div[@role="article"]${DK_BL_MA})][${sauBinhLuan(DK_BL_MA)}])[1]` },
  ] }, text: "{{item.tra_loi}}", enter: true },
];

// ===================== ĐĂNG BÀI LÊN TRANG (Page) FACEBOOK (FB 2026-10-03, người dùng duyệt) =====================
// CHỌN CÁCH: trình chuyển hồ sơ của facebook.com (menu ảnh đại diện → "Xem tất cả trang cá nhân" → bấm Trang) rồi soạn bằng hộp "Tạo bài viết" của Trang.
// VÌ SAO (không dùng Meta Business Suite): hộp "Tạo bài viết" + rào vùng 'tao_bai' (chỉ gõ trong đúng hộp — bài học Lexical gõ nhầm ô 02/10) đã có và đã
// kiểm; Business Suite là giao diện khác hẳn (trang soạn riêng, cần mã Trang asset_id), chưa đo gì, đổi nhiều. Đổi lại: chuyển hồ sơ là đổi vai CẢ PHIÊN →
// khối LUÔN chuyển về hồ sơ cá nhân ở cuối (luon_chay — kể cả khi dừng giữa chừng) để các kịch bản sau không bình luận dưới tên Trang.
// Chặn trước khi đăng: tên Trang phải có đúng MỘT trong danh sách hồ sơ (so chuan_ten: hoa/thường + khoảng trắng thừa không quan trọng, dấu phải
// đúng; không bao giờ chọn hồ sơ cá nhân), nội dung ≤ 3000 ký tự, người đăng hiện trong hộp "Tạo bài viết" phải là Trang, nút Đăng phải đang bật.
// Hậu kiểm: bài vừa đăng (đầu chữ trùng) đứng tên Trang.
// Giả định T1–T4 (trang giả tests/e2e/fb-trang-gia.mjs dựng theo) — ĐỐI CHIẾU KHẢO SÁT THẬT 04/10/2026 (menu_ho_so, hop_tao_bai_ca_nhan,
// trang_ca_nhan_toi, trang_chu; hàng rào tests/unit/dom/khao-sat-0410-hang-rao.test.ts):
//  T1 nút ảnh đại diện: ĐÃ ĐO — div[role=button] aria-label "Trang cá nhân của bạn" trong navigation "Cài đặt và kiểm soát tài khoản" (menu_ho_so #15);
//     bấm → div[role=dialog] aria-label "Trang cá nhân của bạn" (#18).
//  T2 danh sách hồ sơ: nút "Xem tất cả trang cá nhân" ĐÃ ĐO gián tiếp (bước tuỳ chọn của khảo sát bấm được → khung "Chọn trang cá nhân" có nút "Quay lại
//     menu trước"); mỗi hồ sơ một [role=listitem] (#22 #24), hồ sơ cá nhân ĐẦU. LỆCH → ĐÃ SỬA: aria-label của nút KHÔNG chỉ là tên mà là
//     "Tên, N thông báo[, đang chọn]" ("<tên>, 6 thông báo, đang chọn" / "<Trang>, 8 thông báo") → trường ten bỏ phần đuôi đó (trước đây so
//     chuan_ten với tên Trang luôn sai → "không có Trang nào"); về hồ sơ cá nhân so nhãn bằng HOẶC bắt đầu bằng "Tên,". Mục "Tạo Trang" (#26) không nhãn.
//  T3 sau khi bấm Trang: CHƯA ĐO (không được chuyển vai trên nick thật). Ô mở soạn ĐÃ ĐO trên trang cá nhân: div[role=button] chữ "Bạn đang nghĩ gì?"
//     (trang_ca_nhan_toi #134); trên trang chủ chữ là "<Tên> ơi, bạn đang nghĩ gì thế?" (trang_chu #48, 'bạn' viết thường) → thêm nấc cho dạng này.
//  T4 hộp "Tạo bài viết": ĐÃ ĐO — role=dialog aria-label "Tạo bài viết" + h2 "Tạo bài viết" (#17–#19), ô Lexical KHÔNG nhãn (#24), nút div[role=button]
//     aria-label "Đăng" (#35). CHƯA ĐO: span tên người đăng (khảo sát không ghi span trơn) và aria-disabled khi mờ (khảo sát không ghi thuộc tính này).
export const NUT_ANH_DAI_DIEN = { describe: "nút ảnh đại diện (menu tài khoản) góc trên bên phải", ladder: [
  { t: "css", sel: 'div[role="button"][aria-label="Trang cá nhân của bạn"]' },
  { t: "css", sel: 'div[role="button"][aria-label="Your profile"]' },
  { t: "xpath", xpath: '(//div[@role="navigation" or @role="banner"]//div[@role="button"][@aria-label="Trang cá nhân của bạn" or @aria-label="Your profile" or @aria-label="Tài khoản" or @aria-label="Account"])[1]' },
] };
const HO_SO_SPEC = {
  mode: "list",
  list: { describe: "các trang cá nhân / Trang trong menu chuyển hồ sơ (hồ sơ cá nhân đầu tiên)", ladder: [
    { t: "css", sel: 'div[role="dialog"] [role="listitem"]' },
    { t: "css", sel: 'div[role="dialog"] [role="radio"]' },
  ] },
  fields: {
    // Nhãn thật (04/10): "<tên>, 6 thông báo, đang chọn" / "<Trang>, 8 thông báo" → chỉ lấy TÊN (bỏ đuôi số thông báo / đang chọn); tên có dấu phẩy giữ nguyên.
    ten: { sel: '[role="button"][aria-label], [role="radio"][aria-label], a[aria-label]', attr: "aria-label", alt: ['span[dir="auto"]'],
      regex: "^\\s*([\\s\\S]+?)(?:,\\s*(?:\\d+\\+?\\s+(?:thông báo|notifications?)|đang chọn|selected|current))*\\s*$" },
  },
  item_key: ["ten"],
  bo_muc_rong: ["ten"],
};
const TRANG_TIMELINE_SPEC = {
  mode: "list",
  list: { describe: "bài trên trang của Trang (mới nhất trước)", ladder: [
    { t: "css", sel: 'div[role="main"] div[aria-posinset][aria-labelledby]' },
    { t: "css", sel: 'div[role="main"] div[role="feed"] > div' },
  ] },
  fields: {
    tac_gia: { sel: 'h2 a[role="link"], h3 a[role="link"], h4 a[role="link"], strong a[role="link"]', attr: "text", alt: ["h2 a", "h3 a", "h4 a", "h2 strong", "h3 strong"] },
    noi_dung: { sel: '[data-ad-rendering-role="story_message"]', attr: "text", alt: ['[data-ad-comet-preview="message"]'] },
  },
  bo_muc_rong: ["tac_gia", "noi_dung"],
};
const DANG_TRANG_ACTIONS = [
  // clear: lần làm lại (AI chẩn đoán "làm lại bước") gõ ĐÈ, không nối thành hai lần chữ.
  { kind: "type", target: { describe: "ô soạn bài trong hộp thoại 'Tạo bài viết' của Trang", vung: "tao_bai", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"][data-lexical-editor="true"]' },
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"]' },
  ] }, text: "{{bai_trang}}", clear: true },
  // Không nấc AI: nút mờ (aria-disabled) thì KHÔNG nấc nào khớp → chờ hết giờ rồi dừng, không bấm.
  { kind: "click", target: { describe: "nút Đăng ĐANG BẬT trong hộp thoại 'Tạo bài viết' (nút mờ = không đăng)", vung: "tao_bai", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Đăng"]:not([aria-disabled="true"])' },
    { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Post"]:not([aria-disabled="true"])' },
    { t: "xpath", xpath: '(//div[@role="dialog"]//div[@role="button"][normalize-space()="Đăng" or normalize-space()="Post"][not(@aria-disabled="true")])[1]' },
  ] } },
];
const TRANG_TOI_DA = 3000; // ký tự — bài Trang dài hơn thế coi là nhầm (Facebook cho ~63 nghìn; bài quảng bá thực tế < 1–2 nghìn; gõ từng ký tự rất lâu)

// ===================== BÌNH LUẬN MỘT BÀI — ĐỂ TRỐNG ĐỊA CHỈ: TỰ TÌM BÀI TRONG NHÓM ĐÃ THAM GIA (05/10/2026, người dùng duyệt) =====================
// Người dùng không biết địa chỉ bài → bot tự tìm: chọn MỘT nhóm nick ĐÃ THAM GIA có tên hợp từ khoá của kịch bản (trang "Nhóm của bạn" — bộ chọn của lướt bảng
// tin, src/shared/luot-nhom.ts; từ khoá bỏ hư từ như tự chọn nhóm đăng), lướt bảng tin nhóm đó gom bài (bỏ bài của CHÍNH nick — bo_cua_nick), lọc bài quá ngắn /
// quảng cáo-tuyển dụng / đã bình luận (sổ cái da_binh_luan dùng chung với "Bình luận các bài tìm được"), [AI chấm liên quan khi có sản phẩm/mục tiêu], rồi
// MỞ ĐÚNG trang của bài đó (liên kết /groups/<nhóm>/posts/<số>) và bình luận bằng ĐÚNG đường của bài theo địa chỉ (rào vùng bai_dich — không gõ nhầm bài gợi ý /
// bài khác). Một mục, for_each: sổ cái + chống trùng Boss (bai_da_lam) theo bài như các khối tìm-rồi-làm. Không có nhóm hợp → 0 bài, lần chạy KHÔNG CÓ VIỆC
// (lý do rõ, không dừng cả lượt, không lướt trang chủ); trang đăng nhập / xác minh → bước lướt lỗi → dừng. Cần plugin ≥ 0.1.54 (lướt chi_nhom_da_vao).
const BAI_NHOM_TU_TIM_SPEC = {
  ...BANG_TIN_SPEC,
  fields: {
    ...BANG_TIN_SPEC.fields,
    // Địa chỉ ĐẦY ĐỦ của bài (thuộc tính href của thẻ a là địa chỉ tuyệt đối) — trang bài để bình luận bằng đường một bài (bai_dich).
    bai_url: { sel: 'a[href*="/posts/"], a[href*="/permalink/"]', attr: "href", regex: "^(https?://[^?#]*?/groups/[^/?#]+/(?:posts|permalink)/\\d+)" },
  },
};
const LY_DO_KHONG_BAI_NHOM = "Không tìm được bài phù hợp để bình luận lúc này (không có nhóm đã tham gia nào hợp từ khoá, hoặc bài mới trong nhóm đều quá ngắn / quảng cáo / của chính nick / đã bình luận) — không bình luận bừa";
const TU_TIM_BAI_NHOM = {
  thamSo: "bai_url",
  chung: "fb_bai_nhom",
  yamlTim: `  - id: tk_bai_nhom
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_bai_nhom

  - id: luot_tim_bai_nhom
    when: "len(trim(tk_bai_nhom)) > 0"
    on: web
    extract: "bài mới trong một nhóm đã tham gia hợp từ khoá: tac_gia, noi_dung, bai_url"
    into: ds_bai_nhom
    timeout: 180s

  - id: loc_bai_nhom
    when: "len(trim(tk_bai_nhom)) > 0"
    filter: "len(str(item.bai_url)) > 0 and item.lien_ket_nhom and not item.nut_tham_gia and len(str(item.noi_dung)) > 40 and not la_quang_cao(item.noi_dung)"
    into: ds_bai_nhom`,
  yamlSteps: `  - id: chon_bai_nhom
    when: "len(trim(tk_bai_nhom)) > 0"
    filter: "item.id not in ledger.da_binh_luan"
    into: ds_bai_nhom

  - id: soan_bai_nhom
    for_each: ds_bai_nhom
    max_items: 1
    when: "len(trim(tk_bai_nhom)) > 0"
    generate:
      input: "Bài viết của {{item.tac_gia}} trong nhóm: {{item.noi_dung}} — viết bình luận cho bài này với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 30
      anh: item.anh_url
    into: item.binh_luan

  - id: dang_bai_nhom_tu_tim
    for_each: ds_bai_nhom
    max_items: 1
    when: "len(trim(tk_bai_nhom)) > 0 and len(ds_bai_nhom) > 0"
    ly_do_bo_qua: "${LY_DO_KHONG_BAI_NHOM}"
    on: web
    do: "mở bài {{item.bai_url}}, bấm Viết bình luận, gõ {{item.binh_luan}} rồi Enter"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan`,
  learned: {
    luot_tim_bai_nhom: { extract_spec: BAI_NHOM_TU_TIM_SPEC, luot: { url: "", chi_nhom_da_vao: true, nhom_da_vao: "{{goc}}groups/joins/", tu_khoa_nhom_da_vao: "{{tk_bai_nhom}}", giay: 40, so_bai: 12, so_thich: 0 } },
    loc_bai_nhom: { ly_do_bo: "bài không có liên kết bài / không thuộc nhóm đã tham gia / quá ngắn / quảng cáo-tuyển dụng" },
    chon_bai_nhom: { ly_do_bo: "nick đã bình luận bài này ở lần chạy trước (sổ cái)" },
    dang_bai_nhom_tu_tim: { actions: [{ kind: "navigate", url: "{{item.bai_url}}" }, ...dangMotBaiActions("{{item.binh_luan}}")], kem_anh: kemAnhHoc(2, FB_HAU_KIEM_ANH, { ngu_canh: "{{item.noi_dung}}" }) },
  },
  params: { goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
  chamPhuHop: { danhSach: "ds_bai_nhom", truong: "noi_dung", truocBuoc: "soan_bai_nhom", maxItemsTu: "__mot_muc", anh: "anh_url" },
};

// Khối "nghỉ" như người — lặp lại được trong một kịch bản (tu-dung.ts laKhoiLapLai). Dùng chung cho mọi mạng (chỉ là bước wait).
export const KHOI_NGHI: KhoiMau = {
  ten: "nghi",
  // L-102 (07/10/2026): mô tả hiện ở hộp Thêm bước — nói bằng chữ thường, không lộ tên tham số nội bộ.
  moTa: "Nghỉ NGẪU NHIÊN một lúc giữa hai thao tác — số giây chọn ngẫu nhiên trong khoảng từ “ít nhất” đến “nhiều nhất” bạn đặt — như người dừng tay (không làm gì trên trang). Dùng được nhiều lần trong một kịch bản, nhưng không đặt hai bước nghỉ liền nhau. Nháp rút ngắn còn 1/10.",
  thamSo: [
    { ten: "tu_giay", moTa: "nghỉ ít nhất bao nhiêu giây (5-600)", kieu: "so", batBuoc: true, min: 5, max: 600 },
    { ten: "den_giay", moTa: "nghỉ nhiều nhất bao nhiêu giây (5-900, không nhỏ hơn số giây ít nhất)", kieu: "so", batBuoc: true, min: 5, max: 900 },
  ],
  yamlSteps: `  - id: nghi
    wait: {{ts.tu_giay}}
    wait_max: {{ts.den_giay}}`,
  learned: {},
};

export const KHOI_FACEBOOK: KhoiMau[] = themChiBaiLienQuan([
  {
    ten: "tim_bai",
    moTa: "Tìm bài viết Facebook theo từ khoá rồi lấy danh sách (tac_gia, noi_dung, nut_tham_gia) vào biến ds_bai",
    thamSo: [{ ten: "tu_khoa", moTa: "từ khoá tìm bài viết, tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true }],
    params: { tu_khoa: { type: "string", default: "{{ts.tu_khoa}}", label: "Từ khoá tìm bài viết" } },
    yamlSteps: `  - id: tim_bai
    on: web
    do: "tìm bài viết theo từ khoá {{tu_khoa}}"
    expect: "url chứa /search/posts"

  - id: lay_bai
    on: web
    extract: "bài viết kết quả tìm kiếm: tac_gia, noi_dung, nut_tham_gia"
    into: ds_bai
    min_items: 1`,
    learned: {
      tim_bai: { actions: [{ kind: "navigate", url: "{{goc}}search/posts?q={{tu_khoa}}" }] }, // {{goc}} = trang gốc nền tảng, thay lúc lắp
      lay_bai: { extract_spec: POST_LIST_SPEC },
    },
  },
  {
    ten: "binh_luan_bai",
    moTa: "Với danh sách ds_bai đã có: bỏ bài quá ngắn, bài nhóm chưa tham gia (có nút Tham gia) và bài đã bình luận (sổ cái); AI soạn bình luận bám nội dung theo knowledge; bấm Viết bình luận, gõ và Enter (rủi ro cao, ghi sổ cái)",
    thamSo: [{ ten: "so_bai", moTa: "số bài tối đa sẽ bình luận trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 }, ...TS_KEM_ANH_TAT_CA],
    chamPhuHop: { danhSach: "ds_bai", truong: "noi_dung", truocBuoc: "soan", maxItemsTu: "so_bai", anh: "anh_url" },
    yamlSteps: `  - id: loc_nhom_chua_tham_gia
    filter: "not item.nut_tham_gia"

  - id: chon_bai
    filter: "item.lien_ket_nhom and len(item.noi_dung) > 40 and item.id not in ledger.da_binh_luan"

  - id: soan
    for_each: ds_bai
    max_items: {{ts.so_bai}}
    generate:
      input: "Bài viết của {{item.tac_gia}}: {{item.noi_dung}}"
      guide: knowledge
      max_words: 30
      anh: item.anh_url
    into: item.binh_luan

  - id: dang_binh_luan
    for_each: ds_bai
    max_items: {{ts.so_bai}}
    on: web
    do: "bấm nút Viết bình luận của bài viết này, gõ {{item.binh_luan}} vào ô Viết bình luận rồi Enter"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: DANG_ACTIONS, kem_anh: kemAnhHoc(1, FB_HAU_KIEM_ANH, { ngu_canh: "{{item.noi_dung}}" }) } },
  },
  {
    ten: "dang_bai_nhom",
    moTa: "Đăng MỘT bài vào nhóm Facebook đã tham gia: AI soạn bài từ hồ sơ/knowledge theo chủ đề, mở ô soạn của nhóm, gõ rồi bấm Đăng (rủi ro cao — có cổng duyệt). Cần đã là thành viên nhóm. Bỏ trống nhom_url = bot TỰ CHỌN một nhóm nick ĐÃ VÀO hợp từ khoá/chủ đề theo dữ liệu của chính bot (bỏ nhóm chờ duyệt, nhóm từng chặn đăng, nhóm vừa đăng trong gian_cach_dang_ngay ngày; thiếu dữ liệu thì xem trang Nhóm của bạn), kiểm nhóm có ô đăng bài; không nhóm nào hợp → dừng, không đăng.",
    thamSo: [
      { ten: "nhom_url", moTa: "địa chỉ nhóm (https://www.facebook.com/groups/...); bỏ trống = bot tự chọn nhóm đã tham gia hợp chủ đề", kieu: "chuoi", batBuoc: false },
      { ten: "chu_de", moTa: "chủ đề bài viết, ví dụ: mẹo chọn phần mềm dựng nhà 3D", kieu: "chuoi", batBuoc: true },
      { ten: "tu_khoa_chon_nhom", moTa: "từ khoá để tự chọn nhóm khi bỏ trống nhom_url (cách nhau dấu phẩy); bỏ trống = theo chủ đề", kieu: "chuoi", batBuoc: false },
      { ten: "gian_cach_dang_ngay", moTa: "không đăng lại vào CÙNG một nhóm trong số ngày này khi tự chọn nhóm (0-30; 0 = không giãn cách)", kieu: "so", batBuoc: false, macDinh: "3", min: 0, max: 30 },
    ],
    params: {
      nhom_url: { type: "string", default: "{{ts.nhom_url}}", label: "Địa chỉ nhóm" }, chu_de: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài viết" },
      tu_khoa_chon_nhom: { type: "string", default: "{{ts.tu_khoa_chon_nhom}}", label: "Từ khoá chọn nhóm (khi bỏ trống địa chỉ nhóm)" },
      gian_cach_dang_ngay: { type: "number", default: "{{ts.gian_cach_dang_ngay}}", label: "Giãn cách đăng cùng nhóm (ngày)" },
    },
    yamlSteps: `  - id: mo_nhom
    on: web
    do: "mở nhóm {{nhom_url}}"
    expect: "url chứa /groups/"

  - id: soan_bai
    generate:
      input: "Viết bài đăng nhóm Facebook về: {{chu_de}}"
      guide: knowledge
      max_words: 120
    into: bai_viet

  - id: dang_bai_nhom
    on: web
    do: "bấm ô soạn của nhóm, gõ {{bai_viet}} rồi bấm Đăng"
    expect: "thấy chữ '{{bai_viet}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_dang_nhom`,
    learned: {
      // chon_nhom (04/10/2026): có địa chỉ → mở như cũ (đường actions); RỖNG → plugin tự chọn nhóm (src/background/runner.ts runChonNhom) — bundle
      // khai can_plugin (src/shared/phien-ban-plugin.ts) nên plugin cũ không nhận. kiem_dang = ô soạn của nhóm (không có = nhóm không cho đăng → bỏ).
      mo_nhom: { actions: [{ kind: "navigate", url: "{{nhom_url}}" }], chon_nhom: CHON_NHOM_DANG },
      dang_bai_nhom: { actions: DANG_NHOM_ACTIONS, ghi_nhom: { su_kien: "dang" } },
    },
  },
  {
    ten: "thich_binh_luan",
    moTa: "Thích MỘT bình luận cụ thể trên một bài (tìm bình luận theo chữ nó chứa). Dùng cho đội nhiều nick cùng đỡ một bình luận. Bấm hai lần sẽ BỎ thích nên có sổ cái chặn làm lại.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ bài viết chứa bình luận", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bình luận cần thích (đủ riêng để không trùng bình luận khác)", kieu: "chuoi", batBuoc: true },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài viết" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bình luận" } },
    yamlSteps: `  - id: mo_bai
    on: web
    do: "mở bài {{bai_url}}"
    expect: "thấy chữ '{{chu_binh_luan}}'"

  - id: thich_bl
    on: web
    do: "bấm Thích ở bình luận có chữ {{chu_binh_luan}}"
    expect: "nút Thích của bình luận đó chuyển sang đã thích"
    risk: high
    idempotent: unsafe
    timeout: 40s
    ledger: da_thich`,
    learned: {
      mo_bai: { actions: [{ kind: "navigate", url: "{{bai_url}}" }] },
      // Hậu kiểm: nút "Thích" CHƯA bấm của đúng bình luận đó không còn (Facebook đổi nhãn sau khi thích). CHƯA KIỂM THẬT trên
      // Facebook — nếu Facebook giữ nguyên nhãn thì bước báo hụt và DỪNG; sổ cái đã ghi ngay khi bấm nên không bao giờ bấm lần hai.
      thich_bl: { actions: THICH_ACTIONS, postcondition: [{ t: "locator_gone", target: { describe: "nút Thích chưa bấm của bình luận đó", ladder: [
        { t: "xpath", xpath: `(//div[@role="button"][@aria-label="Thích"]${CUA_BL_DICH})[1]` },
      ] } }] },
    },
  },
  {
    ten: "tra_loi_mot_binh_luan",
    moTa: "Trả lời ĐÚNG một bình luận cụ thể (tìm theo chữ nó chứa): AI soạn câu trả lời từ hồ sơ rồi gõ vào ô trả lời của chính bình luận đó. Rủi ro cao — có cổng duyệt, sửa được câu trước khi gửi.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ bài viết chứa bình luận", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bình luận cần trả lời", kieu: "chuoi", batBuoc: true },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài viết" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bình luận" } },
    yamlSteps: `  - id: mo_bai
    on: web
    do: "mở bài {{bai_url}}"
    expect: "thấy chữ '{{chu_binh_luan}}'"

  - id: soan_tra_loi
    generate:
      input: "Trả lời bình luận này như một người xem khác, không phải người viết bài: {{chu_binh_luan}}"
      guide: knowledge
      max_words: 30
    into: cau_tra_loi

  - id: gui_tra_loi
    on: web
    do: "bấm Phản hồi ở bình luận có chữ {{chu_binh_luan}}, gõ {{cau_tra_loi}} rồi gửi"
    expect: "thấy chữ '{{cau_tra_loi}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_tra_loi_bl`,
    learned: {
      mo_bai: { actions: [{ kind: "navigate", url: "{{bai_url}}" }] },
      gui_tra_loi: { actions: TRA_LOI_ACTIONS, postcondition: TRA_LOI_HAU_KIEM, kem_anh: kemAnhHoc(1, FB_HAU_KIEM_ANH, { ngu_canh: "{{chu_binh_luan}}" }) },
    },
  },
  {
    ten: "binh_luan_mot_bai",
    moTa: "Bình luận vào MỘT bài: có địa chỉ (bai_url) → đúng bài đó (dùng khi muốn nhiều nick cùng vào một bài); ĐỂ TRỐNG địa chỉ → bot TỰ TÌM một bài mới trong nhóm nick ĐÃ THAM GIA có tên hợp từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu), bỏ bài quá ngắn, quảng cáo, bài của chính nick, bài đã bình luận; có sản phẩm/mục tiêu thì AI chấm bài liên quan; không có bài hợp → không làm gì (không bình luận bừa). AI soạn câu từ hồ sơ rồi gõ vào ô bình luận của ĐÚNG bài đó. Rủi ro cao — có cổng duyệt, sửa được câu trước khi gửi.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ bài viết cần bình luận — Không bắt buộc — để trống thì bot tự tìm bài phù hợp theo từ khoá (bài mới trong nhóm đã tham gia hợp chủ đề)", kieu: "chuoi", batBuoc: false },
      { ten: "goc_nhin", moTa: "góc nhìn của nick này để mỗi nick nói một kiểu, ví dụ: người mới tìm hiểu / đã dùng 2 năm / hỏi giá", kieu: "chuoi", batBuoc: false },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: {
      bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài viết" },
      goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" },
    },
    yamlSteps: `  - id: mo_bai
    on: web
    do: "mở bài {{bai_url}}"
    expect: "url chứa {{bai_url}}"

  - id: soan
    generate:
      input: "Viết bình luận cho bài này với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 30
    into: binh_luan

  - id: dang_binh_luan
    on: web
    do: "bấm Viết bình luận của bài này, gõ {{binh_luan}} rồi Enter"
    expect: "thấy chữ '{{binh_luan}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_binh_luan`,
    learned: {
      mo_bai: { actions: [{ kind: "navigate", url: "{{bai_url}}" }] },
      dang_binh_luan: { actions: DANG_MOT_BAI_ACTIONS, kem_anh: kemAnhHoc(1, FB_HAU_KIEM_ANH, { ngu_canh: "{{goc_nhin}}" }) },
    },
    tuTim: TU_TIM_BAI_NHOM,
  },
  {
    ten: "tim_nhom",
    moTa: "Tìm NHÓM Facebook theo từ khoá rồi lấy danh sách nhóm vào biến ds_nhom: ten_nhom, nhom_url, trang_thai (da_tham_gia / chua_tham_gia / cho_duyet / khong_ro), thanh_vien (số thành viên nếu có), che_do (Công khai / Riêng tư). Chỉ đọc, không bấm gì.",
    thamSo: [{ ten: "tu_khoa", moTa: "từ khoá tìm nhóm (chủ đề cộng đồng), tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true }],
    params: { tu_khoa_nhom: { type: "string", default: "{{ts.tu_khoa}}", label: "Từ khoá tìm nhóm" } },
    trangThu: "https://www.facebook.com/search/groups?q=trang%20tr%C3%AD%20nh%C3%A0",
    yamlSteps: `  - id: tim_nhom
    on: web
    do: "tìm nhóm theo từ khoá {{tu_khoa_nhom}}"
    expect: "url chứa /search/groups"

  - id: lay_nhom
    on: web
    extract: "nhóm trong kết quả tìm kiếm: ten_nhom, nhom_url, trang_thai, thanh_vien"
    into: ds_nhom
    min_items: 1`,
    learned: {
      tim_nhom: { actions: [{ kind: "navigate", url: "{{goc}}search/groups?q={{tu_khoa_nhom}}" }] },
      lay_nhom: { extract_spec: NHOM_LIST_SPEC },
    },
  },
  {
    ten: "tham_gia_nhom",
    moTa: "Với danh sách ds_nhom vừa tìm: mở từng nhóm CHƯA tham gia và bấm 'Tham gia nhóm' (rủi ro cao — Chạy thật dừng hỏi duyệt từng nhóm). Bỏ qua nhóm đã tham gia / đang chờ duyệt. Nhóm hỏi câu hỏi kiểm duyệt / nội quy → (tu_tra_loi_cau_hoi = co, mặc định) AI tự trả lời ngắn đúng câu hỏi, chọn đáp án, đồng ý nội quy rồi Gửi (duyệt như bước rủi ro cao, kèm toàn bộ câu trả lời); câu BẮT BUỘC đòi thông tin cá nhân (số điện thoại, email, địa chỉ, giấy tờ, mật khẩu…) hoặc tắt tự trả lời → không gửi, đóng hộp, ghi 'cần người'. Tối đa số nhóm mỗi ngày theo Cài đặt (mặc định 3), tính chung vào hạn mức việc mỗi ngày.",
    thamSo: [{ ten: "so_nhom", moTa: "số nhóm chưa tham gia sẽ xin tham gia trong một lần chạy (1-3)", kieu: "so", batBuoc: true, min: 1, max: 3 }, TS_TU_TRA_LOI_CAU_HOI],
    trangThu: "https://www.facebook.com/groups/nghiendecor.official/",
    // L-66 (vòng 2 FB 01/10): 7/12 nhóm tìm được là nhóm TUYỂN DỤNG / việc làm → bỏ theo TÊN nhóm (không tính vào số nhóm, lấy nhóm kế tiếp);
    // có sản phẩm/mục tiêu thì AI chấm tên nhóm liên quan trước (chamPhuHop) — chỉ xin vào nhóm đúng chủ đề.
    chamPhuHop: { danhSach: "ds_nhom", truong: "ten_nhom", truocBuoc: "tham_gia_nhom", maxItemsTu: "so_nhom" },
    yamlSteps: `  - id: tham_gia_nhom
    for_each: ds_nhom
    max_items: {{ts.so_nhom}}
    when: "item.trang_thai == 'chua_tham_gia' and not la_nhom_lac_de(item.ten_nhom, tu_khoa_nhom)"
    on: web
    do: "mở nhóm {{item.ten_nhom}} rồi bấm Tham gia nhóm"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_tham_gia_nhom`,
    learned: {
      tham_gia_nhom: {
        actions: [{ kind: "navigate", url: "{{item.nhom_url}}" }, { kind: "click", target: NUT_THAM_GIA }],
        bo_qua_khi: [
          { khi: { t: "locator_visible", target: DA_THAM_GIA }, ghi: "đã là thành viên nhóm — không bấm Tham gia", gan: { trang_thai: "da_tham_gia" } },
          { khi: { t: "locator_visible", target: CHO_DUYET }, ghi: "đang chờ quản trị viên duyệt yêu cầu tham gia — bỏ qua", gan: { trang_thai: "cho_duyet" } },
        ],
        nhanh_ket_qua: [
          { khi: { t: "locator_visible", target: HOP_CAU_HOI }, ket: "can_nguoi", ghi: "nhóm có câu hỏi kiểm duyệt / nội quy cần đồng ý — cần người trả lời (máy không tự trả lời)", gan: { trang_thai: "co_cau_hoi" }, dong: DONG_HOP_CAU_HOI, tra_loi: { bat: "{{ts.tu_tra_loi_cau_hoi}}" } },
          { khi: { t: "locator_visible", target: CHO_DUYET }, ket: "ok", ghi: "đã gửi yêu cầu tham gia — chờ quản trị viên duyệt", gan: { trang_thai: "cho_duyet" } },
          { khi: { t: "locator_visible", target: DA_THAM_GIA }, ket: "ok", ghi: "đã tham gia nhóm", gan: { trang_thai: "da_tham_gia" } },
        ],
        dem_ngay: "tham_gia_nhom",
      },
    },
  },
  {
    ten: "luot_bang_tin",
    moTa: "Lướt bảng tin như người đọc: mở MỘT nhóm (nhom_url; bỏ trống = chọn ngẫu nhiên một nhóm ĐÃ tham gia trong ds_nhom nếu có, không có thì bảng tin trang chủ), cuộn từng đoạn ngẫu nhiên, dừng đọc theo độ dài bài, đôi khi cuộn ngược, trong thoi_gian_giay giây hoặc tới khi thấy so_bai_xem bài; gom bài thấy được vào ds_bai (tac_gia, noi_dung, lien_ket) cho bước bình luận sau. Thích ngẫu nhiên tối đa so_thich bài (bỏ quảng cáo, bài đã thích; nếu có tu_khoa_thich thì chỉ bài có từ đó) — mỗi lần thích là rủi ro cao, Chạy thật dừng hỏi duyệt.",
    thamSo: [
      { ten: "nhom_url", moTa: "địa chỉ nhóm cần lướt (https://www.facebook.com/groups/...); bỏ trống = nhóm đã tham gia trong danh sách nhóm vừa tìm, không có thì trang chủ", kieu: "chuoi", batBuoc: false },
      { ten: "thoi_gian_giay", moTa: "lướt khoảng bao nhiêu giây (khuyên 20-600; tối đa 1800 = 30 phút)", kieu: "so", batBuoc: true, min: 20, max: 600 },
      { ten: "so_bai_xem", moTa: "xem tối đa bao nhiêu bài (3-20)", kieu: "so", batBuoc: true, min: 3, max: 20 },
      { ten: "so_thich", moTa: "thích ngẫu nhiên tối đa bao nhiêu bài (khuyên 0-3 — nhiều hơn dễ bị Facebook hạn chế; 0 = không thích)", kieu: "so", batBuoc: false, macDinh: "1", min: 0, max: 3 },
      { ten: "tu_khoa_thich", moTa: "chỉ thích bài có một trong các từ này (cách nhau bằng dấu phẩy); bỏ trống = bài bất kỳ trừ quảng cáo", kieu: "chuoi", batBuoc: false },
    ],
    params: {
      luot_nhom_url: { type: "string", default: "{{ts.nhom_url}}", label: "Nhóm cần lướt (bỏ trống = nhóm đã tham gia / trang chủ)" },
      luot_giay: { type: "number", default: "{{ts.thoi_gian_giay}}", label: "Thời gian lướt (giây)" },
      luot_so_bai: { type: "number", default: "{{ts.so_bai_xem}}", label: "Số bài xem tối đa" },
      luot_so_thich: { type: "number", default: "{{ts.so_thich}}", label: "Số bài thích tối đa" },
      luot_tu_khoa_thich: { type: "string", default: "{{ts.tu_khoa_thich}}", label: "Từ khoá bài để thích" },
    },
    trangThu: "https://www.facebook.com/groups/youtubenewbie/",
    yamlSteps: `  - id: luot_bang_tin
    on: web
    extract: "lướt bảng tin và gom bài: tac_gia, noi_dung, lien_ket"
    into: ds_bai
    timeout: 300s

  - id: thich_khi_luot
    for_each: ds_bai
    max_items: 50
    when: "item.chon_thich"
    ly_do_bo_qua: "Lần lướt này không có bài nào hợp để thích — chỉ lướt xem"
    on: web
    do: "bấm Thích bài viết này"
    risk: high
    idempotent: unsafe
    timeout: 30s
    on_item_error: skip
    ledger: da_thich_bai`,
    learned: {
      luot_bang_tin: { extract_spec: BANG_TIN_SPEC, luot: { url: "{{luot_nhom_url}}", nguon_nhom: "ds_nhom", trang_chu: "{{goc}}", nhom_da_vao: "{{goc}}groups/joins/", tu_khoa_nhom_da_vao: "{{tu_khoa_nhom}},{{luot_tu_khoa_thich}}", giay: "{{luot_giay}}", so_bai: "{{luot_so_bai}}", so_thich: "{{luot_so_thich}}", tu_khoa_thich: "{{luot_tu_khoa_thich}}" } },
      thich_khi_luot: THICH_BAI_LEARNED,
    },
  },
  {
    ten: "thich_bai",
    moTa: "Thích (bấm Thích) tối đa so_bai bài trong danh sách ds_bai vừa có (từ Tìm bài viết hoặc Lướt bảng tin); bỏ bài nhóm CHƯA tham gia, bài quảng cáo/tuyển dụng, bài đã thích; có sản phẩm/mục tiêu thì chỉ thích bài liên quan (AI chấm như bước bình luận). Rủi ro cao — Chạy thật dừng hỏi duyệt; sổ cái chặn bấm lần hai (bấm lần hai là bỏ thích).",
    thamSo: [{ ten: "so_bai", moTa: "số bài tối đa sẽ thích trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 }],
    trangThu: "https://www.facebook.com/groups/youtubenewbie/",
    // L-64 (vòng 2 FB 01/10): sơ đồ đặt Thích TRƯỚC bình luận → bot thích bài TUYỂN DỤNG ở nhóm CHƯA tham gia (bước lọc nằm trong khối bình luận).
    // Khối thích tự lọc như khối bình luận (lọc chung danh sách — bước bình luận sau cũng bỏ đúng các bài này) + chấm liên quan khi có sản phẩm/mục tiêu.
    chamPhuHop: { danhSach: "ds_bai", truong: "noi_dung", truocBuoc: "thich_bai", maxItemsTu: "so_bai", anh: "anh_url" },
    yamlSteps: `  - id: loc_thich_bai
    filter: "not item.nut_tham_gia and not la_quang_cao(item.noi_dung)"

  - id: thich_bai
    for_each: ds_bai
    max_items: {{ts.so_bai}}
    when: "not item.da_thich"
    ly_do_bo_qua: "Các bài đều đã được thích từ trước — không có gì để làm lúc này"
    on: web
    do: "bấm Thích bài viết này"
    risk: high
    idempotent: unsafe
    timeout: 30s
    on_item_error: skip
    ledger: da_thich_bai`,
    learned: { thich_bai: THICH_BAI_LEARNED },
  },
  KHOI_NGHI,
  // ---------- FB 2026-10-03 (người dùng duyệt): trả lời MỌI bình luận dưới bài CỦA MÌNH ----------
  {
    ten: "tra_loi_binh_luan_bai_minh",
    moTa: "Mở bài CỦA MÌNH (bai_url; để trống = lần lượt so_bai bài mới nhất trên trang cá nhân, bỏ bài ghim), bấm 'Xem thêm bình luận/phản hồi' tối đa so_lan_xem_them lần mỗi bài, trả lời bình luận của NGƯỜI KHÁC: bỏ bình luận của chính nick, bình luận nick đã phản hồi (trên trang hoặc sổ cái), bình luận chỉ có ảnh/sticker, bình luận còn phản hồi chưa mở; AI soạn câu đáp như TÁC GIẢ bài theo giọng điệu; bấm Phản hồi ĐÚNG bình luận đó, gõ, Enter (rủi ro cao — có duyệt). Tối đa so_tra_loi câu CẢ LƯỢT. Dùng độc lập.",
    thamSo: [
      { ten: "so_tra_loi", moTa: "số câu trả lời TỐI ĐA trong một lần chạy, tính chung mọi bài (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      { ten: "bai_url", moTa: "địa chỉ MỘT bài của chính mình (https://www.facebook.com/…/posts/…) nếu người dùng đưa; để trống = các bài mới nhất trên trang cá nhân của nick", kieu: "chuoi", macDinh: "" },
      { ten: "so_bai", moTa: "khi để trống địa chỉ bài: số bài mới nhất trên trang cá nhân sẽ xem (1-3)", kieu: "so", macDinh: "1", min: 1, max: 3 },
      { ten: "so_lan_xem_them", moTa: "số lần bấm 'Xem thêm bình luận / phản hồi' tối đa mỗi bài (0-10)", kieu: "so", macDinh: "5", min: 0, max: 10 },
      ...TS_KEM_ANH_TAT_CA,
    ],
    // Tham số kịch bản RIÊNG (bai_minh_url): bai_url là tham số chung của các thao tác MỘT bài khác (thích/trả lời một bình luận) — dùng chung tên thì
    // không ghép được trong một kịch bản.
    params: { bai_minh_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài của mình (để trống = các bài mới nhất trên trang cá nhân)" } },
    trangThu: "https://www.facebook.com/me/",
    yamlSteps: `  - id: ds_bai_minh_dau
    template: "{{bai_minh_url}}"
    into: ds_bai_minh

  - id: mo_trang_ca_nhan
    when: "len(trim(bai_minh_url)) == 0"
    on: web
    do: "mở trang cá nhân của chính nick này"

  - id: lay_bai_minh
    when: "len(trim(bai_minh_url)) == 0"
    on: web
    extract: "các bài mới nhất trên trang cá nhân: lien_ket, ma_bai, tac_gia, ghim"
    into: ds_bai_minh

  - id: bo_bai_ghim
    when: "len(trim(bai_minh_url)) == 0"
    filter: "not item.ghim"
    into: ds_bai_minh

  - id: vong_bai_minh
    for_each: "ds_bai(ds_bai_minh)"
    max_items: {{ts.so_bai}}
    on_item_error: skip
    steps:
      - id: mo_bai_minh
        on: web
        do: "mở bài của mình {{item.lien_ket}}"

      - id: lay_bl_minh
        on: web
        extract: "bình luận cấp 1 dưới bài (đã bấm Xem thêm tối đa {{ts.so_lan_xem_them}} lần): tac_gia, noi_dung, ma_bl, con_phan_hoi_an"
        into: ds_bl_minh
        timeout: 12s

      - id: ghi_ma_bai_minh
        template: "{{item.id}}"
        into: ma_bai_hien

      - id: bo_bl_khong_chu
        filter: "len(trim(item.noi_dung)) > 0"
        into: ds_bl_minh

      - id: bo_bl_khong_ma
        filter: "len(str(item.ma_bl)) > 0"
        into: ds_bl_minh

      - id: bo_bl_phan_hoi_an
        filter: "not item.con_phan_hoi_an"
        into: ds_bl_minh

      - id: bo_bl_da_tra_loi
        filter: "(ma_bai_hien + '/' + str(item.id)) not in ledger.da_tra_loi_bl_minh"
        into: ds_bl_minh

      - id: soan_tl_minh
        for_each: ds_bl_minh
        max_items: {{ts.so_tra_loi}}
        generate:
          input: "Một người vừa bình luận dưới bài đăng CỦA BẠN: {{item.noi_dung}} — (bạn là TÁC GIẢ bài viết: đáp lại đúng điều họ nói, ngắn gọn, tự nhiên, thân thiện; cảm ơn khi hợp; không chèn liên kết hay số điện thoại)"
          guide: knowledge
          max_words: 35
          anh: item.anh_url
        into: item.tra_loi

      - id: gui_tl_minh
        for_each: ds_bl_minh
        max_items: {{ts.so_tra_loi}}
        on: web
        do: "bấm Phản hồi của bình luận này, gõ {{item.tra_loi}} vào ô trả lời rồi Enter"
        expect: "thấy chữ '{{item.tra_loi}}'"
        risk: high
        timeout: 60s
        on_item_error: skip
        ledger: da_tra_loi_bl_minh`,
    learned: {
      mo_trang_ca_nhan: { actions: [{ kind: "navigate", url: "{{goc}}me/" }] },
      // Nháp thật 08/10/2026: nick CHƯA đăng bài nào → trước đây min_items 1 làm đoạn LỖI (đường Facebook dừng, nhánh phụ mất lượt). Danh sách CỦA CHÍNH
      // MÌNH rỗng = không có việc (như lay_bl_minh, video TikTok/YouTube của mình) — chữ đăng nhập trên trang vẫn cảnh báo (ket-qua-chay khongViecDsRong).
      lay_bai_minh: { extract_spec: BAI_MINH_SPEC, khong_viec_khi_rong: "Trang cá nhân của bạn chưa có bài nào — không có bình luận nào để trả lời lúc này" },
      bo_bai_ghim: { ly_do_bo: "bài ghim (không phải bài mới nhất)" },
      vong_bai_minh: { con: {
        mo_bai_minh: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }] },
        // L-97: bài của mình chưa có bình luận = không có việc (sạch), không phải cảnh báo "0 việc SẼ làm — danh sách rỗng".
        lay_bl_minh: { extract_spec: BL_BAI_MINH_SPEC, ghi_khi_rong: "bài chưa có bình luận nào của người khác — 0 việc ở bài này", khong_viec_khi_rong: "Bài của bạn chưa có bình luận nào của người khác — không có gì để trả lời lúc này" },
        bo_bl_khong_chu: { ly_do_bo: "bình luận chỉ có ảnh/sticker (không có chữ) — không trả lời" },
        bo_bl_khong_ma: { ly_do_bo: "không đọc được mã bình luận — không định vị chắc chắn được ô trả lời đúng bình luận, không trả lời" },
        bo_bl_phan_hoi_an: { ly_do_bo: "còn phản hồi chưa mở (đã bấm đủ giới hạn 'Xem thêm') — không chắc nick đã trả lời chưa nên không trả lời" },
        bo_bl_da_tra_loi: { ly_do_bo: "nick đã trả lời ở lần chạy trước (sổ cái)" },
        gui_tl_minh: {
          actions: TL_BAI_MINH_ACTIONS,
          // Hậu kiểm trong MỤC (khối bình luận đang làm): câu phải hiện NGAY DƯỚI bình luận gốc, và không còn ô trả lời nào giữ chữ chưa gửi.
          postcondition: [
            { t: "text_visible", text: "{{item.tra_loi}}" },
            { t: "locator_gone", target: { describe: "ô trả lời còn chữ chưa gửi", ladder: [{ t: "xpath", xpath: `//div[@role="textbox"][@contenteditable="true"]${NHAN_TRA_LOI}[normalize-space(.)!=""]` }] } },
          ],
          gioi_han_luot: "{{ts.so_tra_loi}}",
          kem_anh: kemAnhHoc(1, FB_HAU_KIEM_ANH, { ngu_canh: "{{item.noi_dung}}" }),
        },
      } },
    },
  },
  // ---------- FB 2026-10-03 (người dùng duyệt): đăng bài lên TRANG (Page) ----------
  {
    ten: "dang_bai_trang",
    moTa: `Đăng MỘT bài lên Trang (Page) Facebook nick đang quản lý, ĐỨNG TÊN TRANG: chuyển sang Trang theo tên (menu ảnh đại diện → danh sách trang cá nhân), mở hộp 'Tạo bài viết' của Trang, gõ nội dung (noi_dung nguyên văn, hoặc AI soạn theo chu_de), bấm Đăng (rủi ro cao — có duyệt), kiểm bài vừa đăng đứng tên Trang, rồi chuyển về hồ sơ cá nhân. Dừng có lý do nếu: không có Trang đó, nội dung > ${TRANG_TOI_DA} ký tự, hộp soạn không đứng tên Trang, nút Đăng mờ.`,
    thamSo: [
      { ten: "ten_trang", moTa: "tên Trang Facebook đúng như hiện trên Facebook (hoa/thường, khoảng trắng thừa không quan trọng; dấu phải đúng)", kieu: "chuoi", batBuoc: true },
      { ten: "chu_de", moTa: "chủ đề để AI soạn bài cho Trang (bỏ trống nếu điền sẵn nội dung)", kieu: "chuoi", macDinh: "" },
      { ten: "noi_dung", moTa: `nội dung đăng NGUYÊN VĂN (tối đa ${TRANG_TOI_DA} ký tự); bỏ trống = AI soạn theo chủ đề`, kieu: "chuoi", macDinh: "" },
    ],
    params: {
      ten_trang: { type: "string", default: "{{ts.ten_trang}}", label: "Tên Trang" },
      chu_de_trang: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài Trang (AI soạn)" },
      noi_dung_trang: { type: "string", default: "{{ts.noi_dung}}", label: "Nội dung bài Trang (để trống = AI soạn)" },
    },
    trangThu: "https://www.facebook.com/",
    yamlSteps: `  - id: dat_ten_ca_nhan
    template: "{{ '' }}"
    into: ten_ca_nhan

  - id: lay_noi_dung_trang
    template: "{{noi_dung_trang}}"
    into: bai_trang

  - id: soan_bai_trang
    when: "len(trim(noi_dung_trang)) == 0"
    generate:
      input: "Viết MỘT bài đăng cho Trang Facebook “{{ten_trang}}” (bài đứng tên Trang, giọng của Trang) về: {{chu_de_trang}} — không giả làm khách hàng, không chèn liên kết hay số điện thoại"
      guide: knowledge
      max_words: 150
      max_chars: ${TRANG_TOI_DA}
    into: bai_trang

  - id: mo_menu_ho_so
    on: web
    do: "mở trang chủ Facebook rồi bấm ảnh đại diện (menu tài khoản)"

  - id: xem_tat_ca_ho_so
    on: web
    do: "bấm 'Xem tất cả trang cá nhân' trong menu tài khoản"
    optional: true
    timeout: 8s

  - id: lay_ho_so
    on: web
    extract: "các trang cá nhân / Trang trong menu chuyển hồ sơ: ten"
    into: ds_ho_so
    min_items: 1

  - id: ghi_ten_ca_nhan
    template: "{{ds_ho_so[0].ten}}"
    into: ten_ca_nhan

  - id: chon_trang
    filter: "item._index > 0 and chuan_ten(item.ten) == chuan_ten(ten_trang) and chuan_ten(item.ten) != chuan_ten(ten_ca_nhan)"
    into: ds_ho_so

  - id: chuyen_sang_trang
    for_each: ds_ho_so
    max_items: 1
    on: web
    do: "bấm hồ sơ {{item.ten}} để chuyển sang Trang"
    timeout: 30s

  - id: mo_hop_tao_bai_trang
    on: web
    do: "bấm ô 'Bạn đang nghĩ gì?' của Trang để mở hộp Tạo bài viết"
    timeout: 30s

  - id: doc_ten_nguoi_dang
    on: web
    extract: "tên người đăng hiện trong hộp Tạo bài viết"
    into: ten_nguoi_dang

  - id: dang_bai_trang
    on: web
    do: "gõ {{bai_trang}} vào hộp Tạo bài viết của Trang {{ten_trang}} rồi bấm Đăng"
    expect: "bài hiện trên Trang"
    risk: high
    idempotent: unsafe
    timeout: 90s
    ledger: da_dang_trang

  - id: lay_bai_trang_moi
    on: web
    extract: "các bài mới nhất trên Trang: tac_gia, noi_dung"
    into: ds_bai_trang_moi

  - id: kiem_bai_vua_dang
    filter: "startswith(chuan_ten(item.noi_dung), chuan_ten(dau_chu(bai_trang, 40)))"
    into: ds_bai_trang_moi

  - id: ve_ho_so_ca_nhan
    when: "len(ten_ca_nhan) > 0"
    on: web
    do: "bấm ảnh đại diện rồi chọn hồ sơ cá nhân {{ten_ca_nhan}} để chuyển về"
    timeout: 30s`,
    learned: {
      lay_noi_dung_trang: { dung_neu_sai: [
        { dk: "len(trim(noi_dung_trang)) > 0 or len(trim(chu_de_trang)) > 0", ly_do: "chưa có nội dung lẫn chủ đề để đăng lên Trang — điền một trong hai rồi chạy lại" },
        { dk: `len(bai_trang) <= ${TRANG_TOI_DA}`, ly_do: `nội dung dài {{len(bai_trang)}} ký tự, vượt ngưỡng ${TRANG_TOI_DA} ký tự của một bài Trang — chặn, không đăng (rút gọn rồi chạy lại)` },
      ] },
      soan_bai_trang: { dung_neu_sai: [
        { dk: "len(trim(bai_trang)) > 0", ly_do: "AI chưa soạn được nội dung cho Trang — không đăng" },
        { dk: `len(bai_trang) <= ${TRANG_TOI_DA}`, ly_do: `bài AI soạn dài {{len(bai_trang)}} ký tự, vượt ngưỡng ${TRANG_TOI_DA} — chặn, không đăng` },
      ] },
      mo_menu_ho_so: {
        actions: [{ kind: "navigate", url: "{{goc}}" }, { kind: "click", target: NUT_ANH_DAI_DIEN }],
        postcondition: [{ t: "dom_exists", sel: 'div[role="dialog"]' }],
      },
      xem_tat_ca_ho_so: { actions: [{ kind: "click", target: { describe: "nút 'Xem tất cả trang cá nhân' trong menu tài khoản", ladder: [
        { t: "xpath", xpath: '(//div[@role="dialog"]//*[@role="button" or @role="link"][normalize-space()="Xem tất cả trang cá nhân" or normalize-space()="See all profiles"])[1]' },
      ] } }] },
      lay_ho_so: { extract_spec: HO_SO_SPEC },
      chon_trang: { ly_do_bo: "không phải Trang cần đăng (khác tên, hoặc là hồ sơ cá nhân)", dung_neu_sai: [
        { dk: "len(ds_ho_so) > 0", ly_do: "không có Trang nào tên “{{ten_trang}}” trong danh sách trang cá nhân của nick (so cả dấu; hoa/thường và khoảng trắng thừa không tính) — dừng, không đăng" },
        { dk: "len(ds_ho_so) == 1", ly_do: "có {{len(ds_ho_so)}} Trang cùng tên “{{ten_trang}}” — không biết chọn Trang nào, dừng, không đăng" },
      ] },
      chuyen_sang_trang: { actions: [{ kind: "click", target: { describe: "hồ sơ Trang này trong danh sách (chuyển sang Trang)", within: "item", ladder: [
        { t: "css", sel: '[role="button"][aria-label]' },
        { t: "css", sel: '[role="radio"]' },
        { t: "css", sel: "a[href]" },
      ] } }] },
      mo_hop_tao_bai_trang: {
        actions: [{ kind: "click", target: { describe: "ô mở soạn 'Bạn đang nghĩ gì?' của Trang", ladder: [
          { t: "text", text: "Bạn đang nghĩ gì?", tag: "div" },
          { t: "xpath", xpath: `(//div[@role="main"]//div[@role="button"][contains(normalize-space(.),"Bạn đang nghĩ gì") or contains(normalize-space(.),"What's on your mind")])[1]` },
          // Trang chủ thật (04/10, trang_chu #48): "<Tên> ơi, bạn đang nghĩ gì thế?" — 'bạn' viết thường; tiếng Anh "What's on your mind, <Tên>?".
          { t: "xpath", xpath: `(//div[@role="main"]//div[@role="button"][contains(normalize-space(.),"bạn đang nghĩ gì") or contains(normalize-space(.),"on your mind")])[1]` },
        ] } }],
        postcondition: [{ t: "locator_visible", target: { describe: "ô soạn trong hộp 'Tạo bài viết'", vung: "tao_bai", ladder: [{ t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"]' }] } }],
      },
      doc_ten_nguoi_dang: {
        extract_spec: { mode: "single", attr: "text", target: { describe: "tên người đăng trong hộp 'Tạo bài viết'", vung: "tao_bai", ladder: [
          { t: "xpath", xpath: '(//div[@role="dialog"][.//h2[normalize-space()="Tạo bài viết" or normalize-space()="Create post"]]//h2/following::span[normalize-space()!=""][not(ancestor::*[@role="textbox"])][not(ancestor::*[@role="button"])])[1]' },
        ] } },
        dung_neu_sai: [{ dk: "chuan_ten(ten_nguoi_dang) == chuan_ten(ten_trang)", ly_do: "hộp 'Tạo bài viết' đang đăng dưới tên “{{ten_nguoi_dang}}”, KHÔNG phải Trang “{{ten_trang}}” — dừng, không gõ, không đăng" }],
      },
      dang_bai_trang: { actions: DANG_TRANG_ACTIONS, postcondition: [{ t: "text_visible", text: "{{bai_trang}}" }] },
      lay_bai_trang_moi: { extract_spec: TRANG_TIMELINE_SPEC, chi_khi_xong: "dang_bai_trang" },
      kiem_bai_vua_dang: { chi_khi_xong: "dang_bai_trang", ly_do_bo: "không phải bài vừa đăng", dung_neu_sai: [
        { dk: "len(ds_bai_trang_moi) == 0 or chuan_ten(str(ds_bai_trang_moi[0].tac_gia)) == chuan_ten(ten_trang)", ly_do: "bài vừa đăng đứng tên “{{str(ds_bai_trang_moi[0].tac_gia)}}”, KHÔNG phải Trang “{{ten_trang}}” — kiểm tra / xoá tay ngay" },
      ] },
      ve_ho_so_ca_nhan: {
        actions: [
          { kind: "navigate", url: "{{goc}}" },
          { kind: "click", target: NUT_ANH_DAI_DIEN },
          { kind: "click", target: { describe: "hồ sơ cá nhân “{{ten_ca_nhan}}” trong menu tài khoản", ladder: [
            // Nhãn thật "Tên, N thông báo[, đang chọn]" (khảo sát 04/10) → bằng tên HOẶC bắt đầu bằng "Tên," — không nhận Trang tên dài hơn ("Tên Shop, …").
            { t: "xpath", xpath: '(//div[@role="dialog"]//*[@role="button" or @role="radio" or @role="menuitem" or self::a][@aria-label={{ xpath_chu(ten_ca_nhan) }} or starts-with(@aria-label, concat({{ xpath_chu(ten_ca_nhan) }}, ","))])[1]' },
            { t: "xpath", xpath: '(//div[@role="dialog"]//*[@role="button" or @role="radio" or @role="menuitem" or self::a][contains(normalize-space(.), {{ xpath_chu(ten_ca_nhan) }})])[1]' },
          ] } },
        ],
        luon_chay: true,
      },
    },
  },
]);
